import moment from 'moment';
import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { AssistanceCase } from '../../../../models/assistancecase';
import { Assistancesale } from '../../../../models/assistancesale';
import { ApiService } from '../../../../api/api.service';
import { Country } from '../../../../models/country';
import { State } from '../../../../models/state';
import * as _ from 'lodash';
import { Member } from '../../../../models/member';
import { SelectLocationComponent } from '../../../select-location/select-location.component';
import { AssistanceTicket } from '../../../../models/assistanceticket';
import { TranslateService } from '@ngx-translate/core';
import { AssistanceTicketSvc } from '../../services/assistance-ticket.service';
import { MessageService } from 'primeng/api';
import { LoaderService } from '../../../../api/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../../services/notification.service';
import {
  AssistanceCoverLetter,
  ASSISTANCE_COVER_LETTER_STATUSES_TEXT,
} from 'src/app/models/assistancecoverletter';
import {
  AssistanceCategory,
  TYPE_CATEGORY,
} from 'src/app/models/assistance-category';
import { AssistanceService } from 'src/app/models/assistanceservice';
import { AssistancePlanService } from 'src/app/models/assistance-plan-service';
import { ToastMessageOptions } from 'primeng/api';
import { ConfService } from 'src/app/services/conf.service';
import { TYPE_SERVICES } from 'src/app/models/assistanceservice';
import { AssistanceCaseQuestions } from 'src/app/models/assistancecasequestions';
import { AssistanceGestionByConection } from 'src/app/models/assistancegestionbyconection';
import { Popover } from 'primeng/popover';
import { ClaimService } from 'src/app/services/buca/claim.service';
import { CarModelSinister } from 'src/app/models/sds/car-sinister';
import { Attachment } from 'src/app/models/attachment';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CustomerAddressHistoryComponent } from '../customer-address-history/customer-address-history.component';
import { QUESTION_TYPE } from '../../../../models/question';


export class Location {
  latitude: number;
  longitude: number;
}

@Component({
    selector: 'app-assistance-cases-form',
    templateUrl: './assistance-cases-form.component.html',
    styleUrls: ['./assistance-cases-form.component.css'],
    providers: [AssistanceTicketSvc, MessageService],
    standalone: false
})
export class AssistanceCasesFormComponent implements OnChanges, AfterViewInit, OnInit {
  @Input() assistancecase: AssistanceCase;
  @Input() states: any[];
  @Input() countries: any[];
  @Input() caseLocation: any = {};
  @Input() startCount: any;
  @Input() newMember: EventEmitter<Member>;
  @Input() newMemberCountry: EventEmitter<number>;
  @Input() editevent: EventEmitter<void>;
  @Input() reset: EventEmitter<void>;
  @Input() messageService: MessageService;
  @Output() create = new EventEmitter<AssistanceCase>();
  @Output() memberCreate = new EventEmitter<Member>();

  @Output() changeMessageNavBar = new EventEmitter<string>();

  questions = [];

  client_classification = [];

  isCoverLetterSelected: boolean;
  isConectionSelected: boolean;
  isManualSelected: boolean;
  assitanceCoverLetter: AssistanceCoverLetter;
  assitanceByConection: AssistanceGestionByConection;
  ref;
  largeOffset: any;
  offset: any;

  assistanceCoverLetterStatus = ASSISTANCE_COVER_LETTER_STATUSES_TEXT;
  assistanceCoverLetters: any = [];
  TYPE_SERVICES = TYPE_SERVICES;

  SALE_CANCELLED_THEN_BY_CONNECTION: boolean = false;
  DISABLE_DATA_CLIENT = true;
  id_manual = 0;
  readonly TYPE_SEARCH = {
    COVER_LETTER: 1,
    NAME: 2,
    POLICY: 3,
    REFERENCE: 4,
    RFC: 5,
    SERIE: 6,
    PHONE: 7,
    BY_CONECTION: 8,
    MANUAL_CASE: 90,
    CAR_PLATE: 99,
    CAR_ENGINE_NUMBER: 50,
    CAR_SERIAL_NUMBER: 55,
    EMAIL: 65,
    TAX_NUMBER: 70
  };
  productmanual;
  planmanual;
  products: any[] = [];

  PLAN_BY_CONECTION_ID;

  typeSearch: number = 9;
  search_sale_status = null;

  redirect_to_v2 = false;

  saleClientSelected: any;
  in_use: number;
  in_use_flag = false;
  responseChubb = new EventEmitter<any>();

  showMap = new EventEmitter<boolean>();
  selectProductFocused = new EventEmitter<any>();
  selectFocused = new EventEmitter<any>();
  clearCount = new EventEmitter<boolean>();
  memberLocation = new EventEmitter<any>();
  memberLocationDestination = new EventEmitter<any>();
  stateLocation = new EventEmitter<any>();
  stateId: number;
  country: Country;
  destination_country: Country;
  state: State;
  state_text: string;
  state_district_text: string;
  showStateText = false;
  country_code: any = {
    country_name: '',
    country_local: '',
    iso3166_1: '',
  };
  addressSuggest: any[] = [];
  assistanceProducts: any[] = [];
  shortProducts: any[] = [];
  assistanceplans: any[] = [];
  assistancesales: any[] = [];
  selectedSale: any;
  rating = [];
  editLocation: Location;
  fieldsRequired = {
    member: false,
    address: false,
    programdate: false,
  };
  isMemberDisabled: boolean;
  sale_status: number;
  clearMember = new EventEmitter<boolean>();
  isDisabled = false;
  statesDistrict: any[];
  statesDistrictTicket: any[];
  haveNoSale = false;
  isNewMember = false;
  createnewmember: Member;
  createManualMember: Member;
  assistanncesale = new Assistancesale();
  utcoffset: number;

  assistancecategories: any[] = [];
  plan_id: any = null;
  sale_canceled: boolean = false;
  client_comment = false;
  complete_address = '';
  complete_address2 = '';

  //RESPUESTAS
  preguntaGiranLasLlantas = '¿Las 4 llantas giran correctamente?';
  respuestaGiraLlantas = '';

  preguntaSePuedePonerEnNeutral = '¿Se puede poner en neutral?';
  respuestaSePuedePonerEnNeutral = '';

  preguntaTieneAlgunTipoDeCarga = '¿Tiene algún tipo de carga?';
  respuestaTieneAlgunTipoDeCarga = '';
  //agregando  preguntas más
  preguntaTipoCarga = '¿Qué tipo de carga lleva?';
  respuestaTipoCarga = '';

  preguntaPesoAproximado = '¿Cuál es el peso apróximado de la carga?';
  respuestaPesoAproximado = '';

  preguntaLlantas = '¿Cuál es la llanta que no gira?';
  respuestallantadelanteraizquierda = '';
  respuestaLlantadelanteraderecha = '';
  respuestaLlantatraseraizquierda = '';
  respuestaLlantatraseraderecha = '';

  //--aqui terminan las preguntas nuevas

  preguntaDondeEstaVaradoElVehiculo = '¿Donde está varado el vehículo?';
  respuestaDondeEstaVaradoElVehiculo = '';

  preguntaQueTiempoLlevaVarado = '¿Qué tiempo lleva varado?';
  respuestaQueTiempoLllevaVarado = '';

  preguntaFallaMecanicaOElectrica =
    '¿Considera que la falla es mecánica o eléctrica?';
  respuestaFallaMecanicaOElectrica = '';

  preguntaEsAutomaticoOEstandar = '¿Es automático o estándar?';
  respuestaEsAutomaticoOEstandar = '';

  preguntaTieneAlgunaModificacion = '¿Tiene alguna modificación?';
  respuestaTieneAlgunaModificacion = '';

  preguntaQuienRecibeYAcompaniaElServicio =
    '¿Quién recibe y acompaña el servicio?';
  respuestaQuienRecibeYAcompaniaElServicio = '';

  preguntaIdentificacionPiloto = '¿Qué identificación (piloto) presenta?';
  respuestaIdentificacionPiloto = '';

  preguntaViajaAcompaniante = '¿Viaja con algún acompañante?';
  respuestaViajaAcompaniante = '';

  question12 =
    '¿El frente del vehículo esta hacia alguna pared o área abierta?';
  answerQuestion12 = '';

  preguntaAireLibre = '¿Aire Libre?';
  respuestaAireLibre = '';

  preguntaNivel = '¿Nivel?';
  respuestaNivel = '';

  preguntaLimitanteIngreso = '¿Limitante de altura para el ingreso?';
  respuestaLimitanteIngreso = '';

  /**********Servicio GRUA********************** */
  pregunta11Sub1Grua: AssistanceCaseQuestions;
  pregunta11Sub2Grua: AssistanceCaseQuestions;
  question8Grua: AssistanceCaseQuestions;
  question8Sub1Grua: AssistanceCaseQuestions;
  question8Sub1OptionsGrua = [
    { id: 0, value: 'No = No tiene blindaje' },
    { id: 1, value: 'Nivel 1 = peso de unidad x 1.3' },
    { id: 2, value: 'Nivel 2 = peso de unidad x 1.7' },
    { id: 3, value: 'Nivel 3 = peso de unidad x 2.2' },
    { id: 4, value: 'Nivel 4 = peso de unidad x 2.6' },
    { id: 5, value: 'Nivel 5 en adelante son considerados como equipo pesado' },
  ];
  question8Sub2grua: AssistanceCaseQuestions;
  /**********Servicio Cerrajero***************** */
  pregunta1Cerrajero: AssistanceCaseQuestions;
  pregunta2Cerrajero: AssistanceCaseQuestions;
  pregunta3Cerrajero: AssistanceCaseQuestions;
  pregunta4Cerrajero: AssistanceCaseQuestions;
  /********************************************** */

  /*************Servicio Gasolina**************** */
  pregunta1Gasolina: AssistanceCaseQuestions;
  pregunta2Gasolina: AssistanceCaseQuestions;
  pregunta3Gasolina: AssistanceCaseQuestions;
  pregunta4Gasolina: AssistanceCaseQuestions;
  pregunta5Gasolina: AssistanceCaseQuestions;
  pregunta6Gasolina: AssistanceCaseQuestions;

  /*************Servicio Paso Corriente********** */
  pregunta1PasoCorriente: AssistanceCaseQuestions;
  pregunta1Sub1PasoCorriente: AssistanceCaseQuestions;
  pregunta2PasoCorriente: AssistanceCaseQuestions;
  pregunta2Sub2PasoCorriente: AssistanceCaseQuestions;
  pregunta3PasoCorriente: AssistanceCaseQuestions;
  pregunta4PasoCorriente: AssistanceCaseQuestions;
  pregunta5PasoCorriente: AssistanceCaseQuestions;
  pregunta6PasoCorriente: AssistanceCaseQuestions;
  /**********Servicio cambio de llantas******** */
  pregunta1CambioDeLlantas: AssistanceCaseQuestions;
  pregunta2CambioDeLlantas: AssistanceCaseQuestions;
  pregunta2Sub1CambioDeLlantas: AssistanceCaseQuestions;
  pregunta3CambioDeLlantas: AssistanceCaseQuestions;
  pregunta4CambioDeLlantas: AssistanceCaseQuestions;
  pregunta5CambioDeLlantas: AssistanceCaseQuestions;
  pregunta6CambioDeLlantas: AssistanceCaseQuestions;
  //pregunta7CambioDeLlantas: AssistanceCaseQuestions;

  /**********Servicio visita medica******** */
  pregunta1Visita: AssistanceCaseQuestions;
  pregunta2Visita: AssistanceCaseQuestions;
  pregunta3Visita: AssistanceCaseQuestions;
  pregunta4Visita: AssistanceCaseQuestions;
  pregunta5Visita: AssistanceCaseQuestions;
  pregunta6Visita: AssistanceCaseQuestions;
  pregunta7Visita: AssistanceCaseQuestions;
  //pregunta7CambioDeLlantas: AssistanceCaseQuestions;

  /*************Servicio ambulancia EMERGENCIA********* */
  pregunta1Emergencia: AssistanceCaseQuestions;
  pregunta2Emergencia: AssistanceCaseQuestions;
  pregunta3Emergencia: AssistanceCaseQuestions;
  pregunta4Emergencia: AssistanceCaseQuestions;
  pregunta5Emergencia: AssistanceCaseQuestions;
  pregunta6Emergencia: AssistanceCaseQuestions;
  pregunta7Emergencia: AssistanceCaseQuestions;
  pregunta8Emergencia: AssistanceCaseQuestions;

  /*************Servicio ambulancia URGENCIA********* */
  pregunta1Urgencia: AssistanceCaseQuestions;
  pregunta2Urgencia: AssistanceCaseQuestions;
  pregunta3Urgencia: AssistanceCaseQuestions;
  pregunta4Urgencia: AssistanceCaseQuestions;
  pregunta5Urgencia: AssistanceCaseQuestions;
  pregunta6Urgencia: AssistanceCaseQuestions;
  pregunta7Urgencia: AssistanceCaseQuestions;
  pregunta8Urgencia: AssistanceCaseQuestions;
  pregunta9Urgencia: AssistanceCaseQuestions;
  pregunta10Urgencia: AssistanceCaseQuestions;

  /*************Servicio ambulancia NO URGENCIA********* */
  pregunta1NoUrgencia: AssistanceCaseQuestions;
  pregunta2NoUrgencia: AssistanceCaseQuestions;
  pregunta3NoUrgencia: AssistanceCaseQuestions;
  pregunta4NoUrgencia: AssistanceCaseQuestions;
  pregunta5NoUrgencia: AssistanceCaseQuestions;
  pregunta6NoUrgencia: AssistanceCaseQuestions;
  pregunta7NoUrgencia: AssistanceCaseQuestions;
  pregunta8NoUrgencia: AssistanceCaseQuestions;
  pregunta9NoUrgencia: AssistanceCaseQuestions;
  pregunta10NoUrgencia: AssistanceCaseQuestions;

  /*************Servicio Grua********* */
  pregunta1Grua: AssistanceCaseQuestions;
  pregunta2Grua: AssistanceCaseQuestions;
  pregunta3Grua: AssistanceCaseQuestions;
  pregunta4Grua: AssistanceCaseQuestions;
  pregunta5Grua: AssistanceCaseQuestions;
  pregunta6Grua: AssistanceCaseQuestions;
  pregunta7Grua: AssistanceCaseQuestions;
  pregunta8Grua: AssistanceCaseQuestions;
  pregunta9Grua: AssistanceCaseQuestions;
  pregunta10Grua: AssistanceCaseQuestions;
  pregunta11Grua: AssistanceCaseQuestions;
  pregunta12Grua: AssistanceCaseQuestions;

  /**********Servicio vidrieria******** */
  pregunta1Vidrieria: AssistanceCaseQuestions;
  pregunta2Vidrieria: AssistanceCaseQuestions;
  pregunta3Vidrieria: AssistanceCaseQuestions;
  pregunta4Vidrieria: AssistanceCaseQuestions;
  pregunta5Vidrieria: AssistanceCaseQuestions;
  pregunta6Vidrieria: AssistanceCaseQuestions;

  /********************Servicio Plomeria***********************/
  pregunta1Plomeria: AssistanceCaseQuestions;
  pregunta2Plomeria: AssistanceCaseQuestions;
  pregunta3Plomeria: AssistanceCaseQuestions;
  pregunta4Plomeria: AssistanceCaseQuestions;
  pregunta5Plomeria: AssistanceCaseQuestions;
  pregunta6Plomeria: AssistanceCaseQuestions;

  /********************Servicio Cerrajeria Domiciliar***********************/
  pregunta1CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta2CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta3CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta4CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta5CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta6CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta7CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta8CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta9CerrajeriaDomiciliar: AssistanceCaseQuestions;

  pregunta7_1CerrajeriaDomiciliar: AssistanceCaseQuestions;
  pregunta8_1CerrajeriaDomiciliar: AssistanceCaseQuestions;

  /********************Servicio Cerrajeria Vial***********************/
  pregunta1CerrajeriaVial: AssistanceCaseQuestions;
  pregunta2CerrajeriaVial: AssistanceCaseQuestions;
  pregunta3CerrajeriaVial: AssistanceCaseQuestions;
  pregunta4CerrajeriaVial: AssistanceCaseQuestions;
  pregunta5CerrajeriaVial: AssistanceCaseQuestions;

  /********************Servicio Plomeria***********************/
  pregunta1Electricidad: AssistanceCaseQuestions;
  pregunta2Electricidad: AssistanceCaseQuestions;
  pregunta3Electricidad: AssistanceCaseQuestions;
  pregunta4Electricidad: AssistanceCaseQuestions;

  /********************Servicio Orientaciones Medicas Telefónicas***********************/
  pregunta1OMT: AssistanceCaseQuestions;
  pregunta2OMT: AssistanceCaseQuestions;
  pregunta3OMT: AssistanceCaseQuestions;
  pregunta4OMT: AssistanceCaseQuestions;
  pregunta5OMT: AssistanceCaseQuestions;
  pregunta6OMT: AssistanceCaseQuestions;

  /********************Servicio Orientaciones Medicas Telefónicas***********************/
  pregunta1OVT: AssistanceCaseQuestions;
  pregunta2OVT: AssistanceCaseQuestions;
  pregunta3OVT: AssistanceCaseQuestions;
  pregunta4OVT: AssistanceCaseQuestions;
  pregunta5OVT: AssistanceCaseQuestions;
  pregunta6OVT: AssistanceCaseQuestions;
  pregunta7OVT: AssistanceCaseQuestions;

  /********************Servicio Orientaciones Medicas Telefónicas***********************/
  pregunta1OT: AssistanceCaseQuestions;
  pregunta2OT: AssistanceCaseQuestions;

  /********************Servicio Reparacion/Instalacion pantalla ***********************/
  pregunta1SrvPantalla: AssistanceCaseQuestions;
  pregunta2SrvPantalla: AssistanceCaseQuestions;
  pregunta3SrvPantalla: AssistanceCaseQuestions;
  pregunta4SrvPantalla: AssistanceCaseQuestions;
  pregunta5SrvPantalla: AssistanceCaseQuestions;
  pregunta6SrvPantalla: AssistanceCaseQuestions;
  pregunta7SrvPantalla: AssistanceCaseQuestions;
  pregunta8SrvPantalla: AssistanceCaseQuestions;
  pregunta9SrvPantalla: AssistanceCaseQuestions;
  pregunta10SrvPantalla: AssistanceCaseQuestions;
  pregunta11SrvPantalla: AssistanceCaseQuestions;
  pregunta12SrvPantalla: AssistanceCaseQuestions;
  pregunta13SrvPantalla: AssistanceCaseQuestions;
  pregunta14SrvPantalla: AssistanceCaseQuestions;
  pregunta15SrvPantalla: AssistanceCaseQuestions;
  pregunta16SrvPantalla: AssistanceCaseQuestions;
  pregunta17SrvPantalla: AssistanceCaseQuestions;
  pregunta18SrvPantalla: AssistanceCaseQuestions;
  pregunta19SrvPantalla: AssistanceCaseQuestions;
  pregunta20SrvPantalla: AssistanceCaseQuestions;
  pregunta21SrvPantalla: AssistanceCaseQuestions;

  /********************Servicio Orientaciones Medicas Telefónicas***********************/
  pregunta1CitasPresenciales: AssistanceCaseQuestions;
  pregunta2CitasPresenciales: AssistanceCaseQuestions;
  pregunta3CitasPresenciales: AssistanceCaseQuestions;
  pregunta4CitasPresenciales: AssistanceCaseQuestions;
  pregunta5CitasPresenciales: AssistanceCaseQuestions;
  pregunta6CitasPresenciales: AssistanceCaseQuestions;
  pregunta7CitasPresenciales: AssistanceCaseQuestions;
  pregunta8CitasPresenciales: AssistanceCaseQuestions;
  pregunta9CitasPresenciales: AssistanceCaseQuestions;
  pregunta10CitasPresenciales: AssistanceCaseQuestions;

  /***********************Servicio Laboratorios********************************/
  pregunta1Laboratorios: AssistanceCaseQuestions;
  pregunta2Laboratorios: AssistanceCaseQuestions;
  pregunta3Laboratorios: AssistanceCaseQuestions;
  pregunta4Laboratorios: AssistanceCaseQuestions;
  pregunta5Laboratorios: AssistanceCaseQuestions;
  pregunta6Laboratorios: AssistanceCaseQuestions;
  pregunta7Laboratorios: AssistanceCaseQuestions;
  pregunta8Laboratorios: AssistanceCaseQuestions;
  pregunta9Laboratorios: AssistanceCaseQuestions;
  pregunta10Laboratorios: AssistanceCaseQuestions;
  pregunta11Laboratorios: AssistanceCaseQuestions;
  pregunta12Laboratorios: AssistanceCaseQuestions;
  /***********************Servicio Vial********************************/
  pregunta1SiniestroVial: AssistanceCaseQuestions;
  pregunta2SiniestroVial: AssistanceCaseQuestions;
  // pregunta3SiniestroVial: AssistanceCaseQuestions;
  // pregunta4SiniestroVial: AssistanceCaseQuestions;
  pregunta5SiniestroVial: AssistanceCaseQuestions;
  pregunta6SiniestroVial: AssistanceCaseQuestions;
  // pregunta7SiniestroVial: AssistanceCaseQuestions[]=[];
  pregunta8SiniestroVial: AssistanceCaseQuestions;
  /*********************** Servicio Nutricional********************************/
  pregunta1Nutricional: AssistanceCaseQuestions;
  pregunta2Nutricional: AssistanceCaseQuestions;
  pregunta3Nutricional: AssistanceCaseQuestions;
  pregunta4Nutricional: AssistanceCaseQuestions;
  pregunta5Nutricional: AssistanceCaseQuestions;
  pregunta6Nutricional: AssistanceCaseQuestions;
  pregunta7Nutricional: AssistanceCaseQuestions;
  pregunta8Nutricional: AssistanceCaseQuestions;
  /*********************** Servicio Traslados Medico********************************/
  pregunta1MedicalTransfer: AssistanceCaseQuestions;
  pregunta2MedicalTransfer: AssistanceCaseQuestions;
  pregunta3MedicalTransfer: AssistanceCaseQuestions;
  pregunta4MedicalTransfer: AssistanceCaseQuestions;
  pregunta5MedicalTransfer: AssistanceCaseQuestions;
  pregunta6MedicalTransfer: AssistanceCaseQuestions;
  pregunta7MedicalTransfer: AssistanceCaseQuestions;
  pregunta8MedicalTransfer: AssistanceCaseQuestions;
  /*********************** Servicio Vehiculo Pesado********************************/
  pregunta1HeavyVehicule: AssistanceCaseQuestions;
  pregunta2HeavyVehicule: AssistanceCaseQuestions;
  pregunta3HeavyVehicule: AssistanceCaseQuestions;
  pregunta4HeavyVehicule: AssistanceCaseQuestions;
  pregunta5HeavyVehicule: AssistanceCaseQuestions;
  pregunta6HeavyVehicule: AssistanceCaseQuestions;
  pregunta7HeavyVehicule: AssistanceCaseQuestions;
  pregunta8HeavyVehicule: AssistanceCaseQuestions;
  /*********************** Servicio Psicológica********************************/
  pregunta1Psychology: AssistanceCaseQuestions;
  pregunta2Psychology: AssistanceCaseQuestions;
  pregunta3Psychology: AssistanceCaseQuestions;
  pregunta4Psychology: AssistanceCaseQuestions;
  pregunta5Psychology: AssistanceCaseQuestions;
  pregunta6Psychology: AssistanceCaseQuestions;
  pregunta7Psychology: AssistanceCaseQuestions;
  pregunta8Psychology: AssistanceCaseQuestions;
  /*********************** Servicio Tecnológico********************************/
  pregunta1Technological: AssistanceCaseQuestions;
  pregunta2Technological: AssistanceCaseQuestions;
  pregunta3Technological: AssistanceCaseQuestions;
  pregunta4Technological: AssistanceCaseQuestions;
  pregunta5Technological: AssistanceCaseQuestions;
  /*********************** Servicio Legal********************************/
  pregunta1Legal: AssistanceCaseQuestions;
  pregunta2Legal: AssistanceCaseQuestions;
  pregunta3Legal: AssistanceCaseQuestions;
  pregunta4Legal: AssistanceCaseQuestions;
  pregunta5Legal: AssistanceCaseQuestions;
  /*********************** Servicio AMA********************************/
  pregunta1Ama: AssistanceCaseQuestions;
  pregunta2Ama: AssistanceCaseQuestions;
  pregunta3Ama: AssistanceCaseQuestions;
  pregunta4Ama: AssistanceCaseQuestions;
  pregunta5Ama: AssistanceCaseQuestions;
  pregunta6Ama: AssistanceCaseQuestions;
  /*********************** Servicio Dental********************************/
  pregunta1Dental: AssistanceCaseQuestions;
  pregunta2Dental: AssistanceCaseQuestions;
  pregunta3Dental: AssistanceCaseQuestions;
  pregunta4Dental: AssistanceCaseQuestions;
  pregunta5Dental: AssistanceCaseQuestions;
  pregunta6Dental: AssistanceCaseQuestions;
  pregunta7Dental: AssistanceCaseQuestions;
  pregunta8Dental: AssistanceCaseQuestions;
  pregunta9Dental: AssistanceCaseQuestions;
  /*********************** Servicio Veterina Ambulancia********************************/
  pregunta1VetAmbulancia: AssistanceCaseQuestions;
  pregunta2VetAmbulancia: AssistanceCaseQuestions;
  pregunta3VetAmbulancia: AssistanceCaseQuestions;
  pregunta4VetAmbulancia: AssistanceCaseQuestions;
  pregunta5VetAmbulancia: AssistanceCaseQuestions;
  pregunta6VetAmbulancia: AssistanceCaseQuestions;
  /*********************** Servicio Visita Domiciliar********************************/
  pregunta1VetVistD: AssistanceCaseQuestions;
  pregunta2VetVistD: AssistanceCaseQuestions;
  pregunta3VetVistD: AssistanceCaseQuestions;
  pregunta4VetVistD: AssistanceCaseQuestions;
  pregunta5VetVistD: AssistanceCaseQuestions;
  pregunta6VetVistD: AssistanceCaseQuestions;
  pregunta7VetVistD: AssistanceCaseQuestions;
  pregunta8VetVistD: AssistanceCaseQuestions;
  /*********************** Servicio Visita a Clinica********************************/
  pregunta1VetVistC: AssistanceCaseQuestions;
  pregunta2VetVistC: AssistanceCaseQuestions;
  pregunta3VetVistC: AssistanceCaseQuestions;
  pregunta4VetVistC: AssistanceCaseQuestions;
  pregunta5VetVistC: AssistanceCaseQuestions;
  pregunta6VetVistC: AssistanceCaseQuestions;
  pregunta7VetVistC: AssistanceCaseQuestions;
  pregunta8VetVistC: AssistanceCaseQuestions;

  car_of_assistance: any;
  planManualSelected: any;

  triageok = false;
  @ViewChild('selectLocationComp')
  selectLocationComponent: SelectLocationComponent;

  // CHUBB SALES
  key: string;
  policy: string;
  inciso: string;
  companyName: string = null;
  reference: string;
  serie: string;
  rfc: string;

  @ViewChild('searchForm') searchForm;

  member: any;
  member_name = '';
  members: any[] = null;
  member_national_id: any;
  sales: any = [];
  sale: any;
  total: number = 0;
  index: number = 0;
  isChubbSaleSelected: boolean;
  serviceSelected: number = null;

  page = 1;
  filter = {};

  searching: Boolean = false;

  relationships = {
    0: 'Self',
    1: 'Spouse',
    2: 'Son',
    3: 'Daughter',
    4: 'Partner',
    5: 'Father',
    6: 'Mother',
    7: 'Father in law',
    8: 'Mother in law',
    9: 'Other',
  };
  filter_member: any = {
    country_id: null,
    name: null,
    national_id: null,
    mobile: null,
    phone: null,
    gender: null,
    email: null,
  };
  // TICKET **
  @Input() disabled: EventEmitter<boolean>;
  captureLocation = new EventEmitter<boolean>();

  messageFlag: boolean;
  editcategory: AssistanceCategory;
  editservice: AssistanceService;
  additionalplanservice: AssistancePlanService;
  selectCategory_id: number;
  selectBrand_id: number;
  selectModel_id: number;
  services: any[] = [];
  fastServices1: any[] = [];
  fastServices2: any[] = [];
  showcarflag = false;
  carbrands: any[] = [];
  carmodels: any[] = [];
  years: number[] = [];
  selectYear: number;
  colors: any[] = [];
  comment = '';
  commentJSON: any = {};
  editticket: AssistanceTicket;
  latitude: any;
  longitude: any;
  iAm = null;
  //in_use: number;
  remaining_assistances: number;
  courtesy_assistances: number;
  inperiod_assistances: number;
  report_time: number;
  used_services: number;
  total_cases: number;
  is_on_waiting_period: boolean;
  messages: ToastMessageOptions[] = [];
  programmed = 0;
  connection = 0;
  recordination = 0;
  pass = true;
  program_type: any;
  program_subtype: any;
  programtime: any;
  assistance_programming_types = [];
  assistance_programming_subtypes = [];
  areAmountsVisible: boolean;
  maxAssistancesReached: boolean;
  waitingTimeFulfilledService = true;
  brandSelected: any;
  gasolineTypes: any[] = [
    { name: 'Magna', id: 1 },
    { name: 'Premium', id: 2 },
    { name: 'Diesel', id: 3 },
  ];

  consumido: number;
  disponible: number;
  excedente2: number;
  intime = 0;
  area_destination: string;
  zone_destination: number;
  // ** TICKET

  noSpecialPlans = null;
  searchDialog: boolean;
  resultDialog: boolean;
  resultDialogMember: boolean;
  country_id: number;
  company_id: string = 'apolo';
  sponsor_id: number;
  is_mok_search: boolean = false;
  mok_url: string;
  mok_sponsor_selected: any;
  sponsors_mok: any[];
  showCountryError: boolean = false;
  showPhonesNumberDialog: boolean = false;
  showMoreServicesDialog: boolean = false;
  showProgramedService: boolean = false;
  flagProgramedService: boolean = false;
  itemSelected: any;
  programTimeService: any;
  commentServiceConfig: string;
  showConfirmByConection: boolean = false;
  showConfirmByRecordination: boolean = false;
  showConfirmManual: boolean = false;
  showConfirmQuitProgram: boolean = false;
  @ViewChild('divServices') divService: ElementRef;
  @ViewChild('cardService') cardService: ElementRef;
  widthOfDiveService: number = 0;
  sponsor: any;
  loaderLocation: boolean = false;
  //variable para el card desplegable de la poliza
  infopoliza: any;
  indexselectsale: number = 0; // agarra el indice del sale seleccionado de los resultados de la busqueda de la poliza
  @ViewChild('billInfo') op: Popover;

  @ViewChild('form') caseForm;
  ambulance_id = [
    19, 139, 155, 241, 475, 518, 521, 522, 526, 531, 532, 619, 631, 637, 133,
    916,
  ];
  visitas_medicas = [105, 236, 362, 657, 670, 684];
  vidrieria = 30;
  stopLightNumber: number = 0;
  totalCount: number = 0;

  countryFilter: any;

  // * SINISTERS

  hasSinisters: boolean = false;
  sinisterList: any[] = [];
  selectedSinister: number | null = null;
  google_address_origen: String = '';
  google_address_destination: String = '';
  //Condicionado
  showUploadFileDialog = false;
  showHistoryDialog = false;
  setSale = new EventEmitter<any>();
  fileTypes: any = {
    112: 'Condicionado',
  };
  caseAttachments: any[] = [];
  totalCountCaseAttachments: number = 0;
  timezoneOffset = 0;
  setAttachment = new EventEmitter<Attachment>();
  showPreviewDialog = false;

  buca_max_amount = 0;
  buca_amount_available = 0;
  buca_currency = '';
  buca_plan = false;
  max_amount_flag = false;
  max_amount_available_flag = false;
  statesTicket: any[];

  caseLocationDestination: any = {};

  isFieldsMemberDataDisabled = true;

  brands = [];
  selectedBrandId: any;
  selectedVehicleId: any;
  vehicles: any[] = [];

  location_key: string = ""

  otherPhone = null;
  checkedPhone = true;
  checkedPhone2 = false;
  selectedPhone = 1;

  QUESTION_TYPE = QUESTION_TYPE;

  constructor(
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private api: ApiService,
    private translate: TranslateService,
    public ticketSvc: AssistanceTicketSvc,
    private router: Router,
    private notificationService: NotificationService,
    public conf: ConfService,
    private bucaConfig: ClaimService,
    public dialog: MatDialog
  ) {
    this.editLocation = new Location();
    this.isChubbSaleSelected = false;

    let loopyear = 1960;
    let last_year = new Date().getUTCFullYear() + 2;
    while (loopyear <= last_year) {
      this.years.push(loopyear);
      loopyear++;
    }
    this.years.reverse();
    this.areAmountsVisible = false;

    this.maxAssistancesReached = false;
    this.waitingTimeFulfilledService = true;
    this.offset = new Date().getTimezoneOffset() / 60;
    this.messageFlag = false;
  }

  ngAfterViewInit() {
    this.country = new Country();
    this.sale_status = null;
    this.newMemberCountry.subscribe((country_id) => {
      this.api.states
        .get(country_id)
        .promise()
        .then((states) => {
          this.states = states;
          this.statesTicket = states;
          if (this.stateId) {
            this.assistancecase.state_id = this.stateId;
          } else {
            this.assistancecase.state_id = this.stateId = this.states[0].id;
          }
          this.state = _.find(this.states, (s) => s.id === this.stateId);
          if (this.state.latitude != null && this.state.longitude != null) {
            this.caseLocation = {
              latitude: this.state.latitude,
              longitude: this.state.longitude,
            };

            this.caseLocationDestination = this.caseLocation;
          }
        });
    });

    this.newMember.subscribe((member) => {
      if (member) {
        this.member.emit(member);
        this.isNewMember = true;
        const filter_assistance = { country_id: member.country };
        this.api.assistances
          .get()
          .filter(filter_assistance)
          .promise()
          .then((resp) => {
            this.assistanceProducts = resp.data;
          });
      }
    });

    if (this.editevent) {
      this.editevent.subscribe((rep) => {
        this.sale_status = null;
      });
    }
    this.setIsMemberDisabled();
  }
  ActivateClientComments() {
    this.client_comment = !this.client_comment;
  }

  // TICKET **
  ngOnInit() {


    this.getTipologies();

    if (this.assistancecase) {
      this.assistancecase.postal_code = '00000';
    }

    this.caseLocationDestination = this.caseLocation;
    this.statesTicket = this.states;

    this.car_of_assistance = new CarModelSinister();
    const d = new Date();
    this.utcoffset = -d.getTimezoneOffset() / 60;

    this.route.queryParams.subscribe((params) => {

      // Redirect to Cases Module V2
      this.redirect_to_v2 = params['redirect_to_v2'] ? true : false;

      if (this.typeSearch == this.TYPE_SEARCH.COVER_LETTER) {
        if (this.showConfirmByConection == true) {
          this.displayButtonByConnection();
        }
        this.sales = [];
        if (params['step'] == 'coverletter1') {
          this.resultDialog = true;
          this.isCoverLetterSelected = false;
        } else if (
          params['step'] == 'coverletter2' &&
          this.assitanceCoverLetter
        ) {
          this.isCoverLetterSelected = true;
          this.resultDialog = false;
        } else if (
          params['step'] == 'coverletter2' &&
          !this.assitanceCoverLetter
        ) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              step: 'coverletter1',
            },
            queryParamsHandling: 'merge',
          });
          this.isCoverLetterSelected = false;
          this.resultDialog = true;
        } else if (params['step'] == 'coverletter3' && this.sale) {
          this.assistanceCoverLetters = [];
          this.isCoverLetterSelected = false;
          this.isChubbSaleSelected = true;
          this.resultDialog = false;
        } else {
          this.isCoverLetterSelected = false;
          this.resultDialog = false;
        }
      }
      //by manual
      else if (this.typeSearch == this.TYPE_SEARCH.MANUAL_CASE) {
        if (this.showConfirmManual == false) {
          //this.displayButtonByConnection();
        }
        this.sales = [];
        if (params['step'] == 'conection2') {
          this.isManualSelected = true;
          this.resultDialog = false;
        } else if (
          params['step'] == 'conection2' &&
          !this.assitanceByConection
        ) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              step: '1',
            },
            queryParamsHandling: 'merge',
          });
          this.isManualSelected = false;
          this.resultDialog = true;
        } else if (params['step'] == '1') {
          this.resultDialog = true;
          this.isManualSelected = false;
        } else {
          this.isManualSelected = false;
          this.resultDialog = false;
        }
      }
      // by conection
      else if (this.typeSearch == this.TYPE_SEARCH.BY_CONECTION) {
        if (this.showConfirmByConection == false) {
          this.displayButtonByConnection();
        }
        this.sales = [];
        if (params['step'] == 'conection2' && this.assitanceByConection) {
          this.isConectionSelected = true;
          this.resultDialog = false;
        } else if (
          params['step'] == 'conection2' &&
          !this.assitanceByConection
        ) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              step: '1',
            },
            queryParamsHandling: 'merge',
          });
          this.isConectionSelected = false;
          this.resultDialog = true;
        } else if (params['step'] == '1') {
          this.resultDialog = true;
          this.isConectionSelected = false;
        } else {
          this.isConectionSelected = false;
          this.resultDialog = false;
        }
      } else {
        this.assistanceCoverLetters = [];
        this.isCoverLetterSelected = false;
        if (params['step'] == '1') {
          this.resultDialog = true;
          this.isChubbSaleSelected = false;
          this.widthOfDiveService = 0;
        } else if (params['step'] == '2') {
          this.isChubbSaleSelected = true;

          this.resultDialog = false;
        } else if (params['step'] == '2' && this.sale) {
          this.isChubbSaleSelected = true;

          this.resultDialog = false;
        } else if (params['step'] == '2' && !this.sale) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              step: '1',
            },
            queryParamsHandling: 'merge',
          });
          this.isChubbSaleSelected = false;
          this.resultDialog = true;
        } else {
          if (params['step']) {
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                step: '1',
              },
              queryParamsHandling: 'merge',
            });
            this.isChubbSaleSelected = false;
            this.resultDialog = true;
          } else {
            this.isChubbSaleSelected = false;
            this.resultDialog = false;
          }
        }
      }
    });

    this.editticket = new AssistanceTicket();
    this.editcategory = new AssistanceCategory();
    this.editservice = new AssistanceService();
    this.additionalplanservice = new AssistancePlanService();

    this.offset = -(new Date().getTimezoneOffset() / 60);
    this.largeOffset = 'GMT' + this.offset;
    this.isCoverLetterSelected = false;

    this.api.assistance_programming_types
      .get()
      .promise()
      .then(
        (resp) => {
          this.assistance_programming_types = resp;
          this.api.carBrands
            .getCarColors()
            .promise()
            .then((resp) => {
              this.colors = resp;
            });
        },
        (e) => { }
      );

    this.api.assistance_no_spacial_plan
      .get()
      .promise()
      .then(
        (resp) => {
          this.noSpecialPlans = resp;
        },
        (e) => {
          this.noSpecialPlans = null;
        }
      );

    if (this.disabled) {
      this.disabled.subscribe((disabled) => {
        this.isDisabled = disabled;
      });
    }

    if (this.reset) {
      this.reset.subscribe(() => {
        console.log('reset!!!!');

        this.editticket = new AssistanceTicket();
        this.editcategory = new AssistanceCategory();
        this.editservice = new AssistanceService();
        this.selectCategory_id = null;
        this.editticket.service_id = null;
        this.selectBrand_id = null;
        this.selectModel_id = null;
        this.selectYear = null;
        this.showcarflag = false;
        this.carbrands = [];
        this.carmodels = [];
        this.services = [];
        this.comment = '';
        this.commentJSON = {};
        this.programmed = 0;
        this.connection = 0;
        this.recordination = 0;
        this.program_type = null;
        this.program_subtype = null;
        this.selectLocationComponent.resetComponent();
        this.hasSinisters = false;
        this.sinisterList = [];
        this.selectedSinister = null;

        if (this.sale_canceled) {
          // set default by connection
          this.connection = 1;
          this.editticket.connection = 1;
        }
        this.resetNums();
      });
    }

    this.getWithOfDivService();

    /********************Grua******************************* */

    this.pregunta11Sub1Grua = new AssistanceCaseQuestions(
      '¿Sus acompañantes se encuentran bien?'
    );
    this.pregunta11Sub2Grua = new AssistanceCaseQuestions(
      '¿Cuántos acompañantes?'
    );

    this.question8Grua = new AssistanceCaseQuestions(
      '¿Tiene alguna modificación?'
    );

    this.question8Sub1Grua = new AssistanceCaseQuestions(
      '¿Qué tipo de modificación tiene?'
    );

    this.question8Sub2grua = new AssistanceCaseQuestions('¿Otro?');

    /****************cerrajero***************************** */
    this.pregunta1Cerrajero = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo por el que requiere el cerrajero?'
    );
    this.pregunta2Cerrajero = new AssistanceCaseQuestions(
      '2. ¿Las llaves se encuentran dentro del vehículo, en que parte?'
    );
    this.pregunta3Cerrajero = new AssistanceCaseQuestions(
      '3. ¿Quién recibe el servicio?'
    );
    this.pregunta4Cerrajero = new AssistanceCaseQuestions(
      '4. ¿Qué identificación presenta?'
    );
    /****************Servicio Gasolina*********************** */
    this.pregunta1Gasolina = new AssistanceCaseQuestions(
      '1. ¿Nombre del Reportante?'
    );
    this.pregunta2Gasolina = new AssistanceCaseQuestions(
      '2. ¿ID de la persona que recibe al tecnico?'
    );
    this.pregunta3Gasolina = new AssistanceCaseQuestions(
      '3. ¿Cuando ocurrio el inconveniente?'
    );
    this.pregunta4Gasolina = new AssistanceCaseQuestions(
      '4. ¿Tipo de combustible?'
    );
    this.pregunta5Gasolina = new AssistanceCaseQuestions(
      '5. ¿Datos de facturación?'
    );
    this.pregunta6Gasolina = new AssistanceCaseQuestions(
      '6. ¿Cantidad de combustible?'
    );
    /*****************Servicio Paso de Corriente*********************************** */
    this.pregunta1PasoCorriente = new AssistanceCaseQuestions(
      '1. ¿Nombre del Reportante?'
    );

    this.pregunta2PasoCorriente = new AssistanceCaseQuestions(
      '2. ¿ID de la persona que recibe al tecnico?'
    );
    this.pregunta2Sub2PasoCorriente = new AssistanceCaseQuestions('');
    this.pregunta3PasoCorriente = new AssistanceCaseQuestions(
      '3. ¿Cuando ocurrio el inconveniente?'
    );
    this.pregunta4PasoCorriente = new AssistanceCaseQuestions(
      '4. ¿Tiene acceso facil a la bateria?'
    );
    this.pregunta5PasoCorriente = new AssistanceCaseQuestions(
      '5. ¿El vehículo es automatico o mecanico?'
    );
    this.pregunta6PasoCorriente = new AssistanceCaseQuestions(
      '6. ¿Tipo de combustible?'
    );

    /*****************Servicio visita medica*********************************** */
    this.pregunta1Visita = new AssistanceCaseQuestions(
      '1. Fecha de activación'
    );

    this.pregunta2Visita = new AssistanceCaseQuestions(
      '2. ¿Nombre del Reportante?'
    );
    this.pregunta3Visita = new AssistanceCaseQuestions(
      '3. Nombre del paciente'
    );
    this.pregunta4Visita = new AssistanceCaseQuestions(
      '4. ¿Cuales son los sintomas?'
    );
    this.pregunta5Visita = new AssistanceCaseQuestions(
      '5. ¿Cual es la edad del paciente?'
    );
    this.pregunta6Visita = new AssistanceCaseQuestions('6. ID del paciente');
    this.pregunta7Visita = new AssistanceCaseQuestions(
      '7. ¿Cual es el Parentesco?'
    );

    /****************Servicio cambio de llantas****************************************** */
    this.pregunta1CambioDeLlantas = new AssistanceCaseQuestions(
      '1. ¿Nombre del Reportante?'
    );
    this.pregunta2CambioDeLlantas = new AssistanceCaseQuestions(
      '2. ¿ID de la persona que recibe al tecnico?'
    );
    /*this.pregunta2Sub1CambioDeLlantas = new AssistanceCaseQuestions(
      '¿Tiene el dado?'
    );*/
    this.pregunta3CambioDeLlantas = new AssistanceCaseQuestions(
      '3. ¿Cuando ocurrio el inconveniente?'
    );
    this.pregunta4CambioDeLlantas = new AssistanceCaseQuestions(
      '4. ¿Cuenta con llanta de repuesto?'
    );
    this.pregunta5CambioDeLlantas = new AssistanceCaseQuestions(
      '5. ¿Se encuentra en buen estado?'
    );
    this.pregunta6CambioDeLlantas = new AssistanceCaseQuestions(
      '6. ¿Tiene algún perno o tuerca especial?'
    );
    /*this.pregunta7CambioDeLlantas = new AssistanceCaseQuestions(
      '7. ¿Qué identificación presenta?'
    );*/

    /*****************Servicio AMBULANCIA EMERGENCIA*********************************** */

    this.pregunta1Emergencia = new AssistanceCaseQuestions(
      '1. Número de contacto'
    );
    this.pregunta2Emergencia = new AssistanceCaseQuestions(
      '2. ¿Cuál es la emergencia?'
    );
    this.pregunta3Emergencia = new AssistanceCaseQuestions(
      '3. ¿Tiene sospechas de COVID?'
    );
    this.pregunta4Emergencia = new AssistanceCaseQuestions(
      '4. Nombre del paciente'
    );
    this.pregunta5Emergencia = new AssistanceCaseQuestions(
      '5. ¿Cuál es el parentesco?'
    );
    this.pregunta6Emergencia = new AssistanceCaseQuestions(
      '6. Edad del paciente'
    );
    this.pregunta7Emergencia = new AssistanceCaseQuestions(
      '7. ¿Se encuentra con paciente?'
    );
    this.pregunta8Emergencia = new AssistanceCaseQuestions(
      '8. Otro número de contacto'
    );

    /*****************Servicio AMBULANCIA URGENCIA*********************************** */
    this.pregunta1Urgencia = new AssistanceCaseQuestions(
      '1. Número de contacto'
    );
    this.pregunta2Urgencia = new AssistanceCaseQuestions(
      '2. ¿Cuál es la emergencia?'
    );
    this.pregunta3Urgencia = new AssistanceCaseQuestions(
      '3. ¿Tiene sospechas de COVID?'
    );
    this.pregunta6Urgencia = new AssistanceCaseQuestions(
      '4. Nombre del paciente'
    );
    this.pregunta7Urgencia = new AssistanceCaseQuestions(
      '5. ¿Cuál es el parentesco?'
    );
    this.pregunta8Urgencia = new AssistanceCaseQuestions(
      '6. Edad del paciente'
    );
    this.pregunta9Urgencia = new AssistanceCaseQuestions(
      '7. ¿Se encuentra con paciente?'
    );
    this.pregunta10Urgencia = new AssistanceCaseQuestions(
      '8. Otro número de contacto'
    );

    /*****************Servicio grua*********************************** */
    this.pregunta1Grua = new AssistanceCaseQuestions(
      '1. ¿Nombre del Reportante?'
    );
    this.pregunta2Grua = new AssistanceCaseQuestions(
      '2. ID de la persona que recibe al tecnico'
    );
    this.pregunta3Grua = new AssistanceCaseQuestions(
      '3. ¿Cuando ocurrio el inconveniente y que le sucedió al vehículo?'
    );
    this.pregunta4Grua = new AssistanceCaseQuestions(
      '4. ¿El vehículo se encuentra sobre sus 4 ruedas?'
    );
    this.pregunta5Grua = new AssistanceCaseQuestions(
      '5. ¿Las 4 ruedas giran con normalidad?'
    );
    this.pregunta6Grua = new AssistanceCaseQuestions(
      '6. ¿Se puede colocar en neutro y liberar el freno de mano?'
    );

    this.pregunta7Grua = new AssistanceCaseQuestions(
      '7. ¿El vehiculo es de uso personal o comercial?'
    );
    this.pregunta8Grua = new AssistanceCaseQuestions(
      '8. ¿El vehículo es de perfil bajo?'
    );
    this.pregunta9Grua = new AssistanceCaseQuestions(
      '9. ¿Cuantas personas le acompañan?'
    );
    this.pregunta10Grua = new AssistanceCaseQuestions(
      '10. Dirección de donde se encuentra el vehículo en este momento'
    );
    this.pregunta11Grua = new AssistanceCaseQuestions(
      '11. Direccion exacta del destino (taller o domicilio)'
    );
    this.pregunta12Grua = new AssistanceCaseQuestions(
      '12. ¿Lleva algún tipo de carga o mercancías?'
    );

    /************************** Servicio Vidrieria **************************/
    this.pregunta5Vidrieria = new AssistanceCaseQuestions('1. Reportante');
    this.pregunta6Vidrieria = new AssistanceCaseQuestions(
      '2. ID o nombre de la persona que recibe al técnico'
    );
    this.pregunta1Vidrieria = new AssistanceCaseQuestions(
      '3. ¿Cuándo ocurrio el inconveniente?'
    );
    this.pregunta2Vidrieria = new AssistanceCaseQuestions(
      '4. ¿En qué parte del domicilio esta el vidrio dañado?'
    );
    this.pregunta3Vidrieria = new AssistanceCaseQuestions(
      '5. ¿El vidrio está en la fachada exterior que da hacia la calle?'
    );
    this.pregunta4Vidrieria = new AssistanceCaseQuestions(
      '6. ¿La venta cuenta con balcon?'
    );

    /************************** Servicio Plomeria **************************/
    this.pregunta5Plomeria = new AssistanceCaseQuestions('1. Reportante');
    this.pregunta6Plomeria = new AssistanceCaseQuestions(
      '2. ID o nombre de la persona que recibe al técnico'
    );
    this.pregunta1Plomeria = new AssistanceCaseQuestions(
      '3. ¿Cuando ocurrio el inconveniente?'
    );
    this.pregunta2Plomeria = new AssistanceCaseQuestions(
      '4. ¿En qué parte de la casa y que fue lo que sucedió?'
    );
    this.pregunta3Plomeria = new AssistanceCaseQuestions(
      '5. ¿Son tuberías PVC?'
    );
    this.pregunta4Plomeria = new AssistanceCaseQuestions(
      '6. ¿La tuberia esta expuesta?  '
    );
    /************************** Servicio Cerrajeria Domiciliar **************************/
    this.pregunta1CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '1. Reportante'
    );
    this.pregunta2CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '2. ID o nombre de la persona que recibe al técnico'
    );
    this.pregunta3CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '3. ¿Cuenta con acceso al domicilio en este momento?'
    );
    this.pregunta4CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '4. ¿Existe otra puerta adicional para tener acceso al domicilio?'
    );
    this.pregunta5CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '5. ¿Cuando ocurrio el inconveniente?'
    );
    this.pregunta6CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '6. ¿Es la puerta principal del domicilio?'
    );
    this.pregunta7CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '7. ¿La puerta es de madera/metalica/otro material?'
    );
    this.pregunta7_1CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '7.1 ¿De que material es la puerta?'
    );
    this.pregunta8CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '8. ¿Qué tipo de cerradura tiene la puerta?'
    );
    this.pregunta8_1CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '8.1 Especifique el tipo de cerradura'
    );
    this.pregunta9CerrajeriaDomiciliar = new AssistanceCaseQuestions(
      '9. ¿Puerta cerrada con doble llave?'
    );
    /************************** Servicio Cerrajeria Vial **************************/
    this.pregunta1CerrajeriaVial = new AssistanceCaseQuestions('1. Reportante');
    this.pregunta2CerrajeriaVial = new AssistanceCaseQuestions(
      '2. ID o nombre de la persona que recibe al técnico'
    );
    this.pregunta3CerrajeriaVial = new AssistanceCaseQuestions(
      '3. ¿Cuando ocurrio el inconveniente?'
    );
    this.pregunta4CerrajeriaVial = new AssistanceCaseQuestions(
      '4. ¿Las llaves estan visibles?'
    );
    this.pregunta5CerrajeriaVial = new AssistanceCaseQuestions(
      '5. ¿Dónde se encuentran las llaves?'
    );

    /************************** Servicio Electricidad **************************/
    this.pregunta3Electricidad = new AssistanceCaseQuestions('1. Reportante');
    this.pregunta4Electricidad = new AssistanceCaseQuestions(
      '2. ID o nombre de la persona que recibe al técnico'
    );
    this.pregunta1Electricidad = new AssistanceCaseQuestions(
      '3. ¿Cuando ocurrio el inconveniente?'
    );
    this.pregunta2Electricidad = new AssistanceCaseQuestions(
      '4. ¿En qué parte de la casa y que fue lo que sucedió?'
    );

    /************************** Servicio OT **************************/
    this.pregunta1OT = new AssistanceCaseQuestions('1. Reportante');
    this.pregunta2OT = new AssistanceCaseQuestions('2. Motivo de consulta');

    /************************** Servicio OMT **************************/
    this.pregunta1OMT = new AssistanceCaseQuestions('1. Fecha de activación');
    this.pregunta2OMT = new AssistanceCaseQuestions('2. Reportante');
    this.pregunta3OMT = new AssistanceCaseQuestions('3. Nombre del paciente');
    this.pregunta4OMT = new AssistanceCaseQuestions('4. Síntomas');
    this.pregunta5OMT = new AssistanceCaseQuestions('5. Edad del paciente');
    this.pregunta6OMT = new AssistanceCaseQuestions('6. Parentesco');

    /************************** Servicio OVT **************************/
    this.pregunta1OVT = new AssistanceCaseQuestions('1. Fecha de activación');
    this.pregunta2OVT = new AssistanceCaseQuestions('2. Reportante');
    this.pregunta3OVT = new AssistanceCaseQuestions('3. Nombre de la mascota');
    this.pregunta4OVT = new AssistanceCaseQuestions('4. Raza');
    this.pregunta5OVT = new AssistanceCaseQuestions('5. Edad de la mascota');
    this.pregunta6OVT = new AssistanceCaseQuestions(
      '6. Peso aproximado de la mascota'
    );
    this.pregunta7OVT = new AssistanceCaseQuestions('7. Sintomas');

    /***************************Servicio Reemplazo Pantalla***************************/
    this.pregunta1SrvPantalla = new AssistanceCaseQuestions('1. Cadena');
    this.pregunta2SrvPantalla = new AssistanceCaseQuestions('2. Tienda');
    this.pregunta3SrvPantalla = new AssistanceCaseQuestions(
      '3. Número de tienda'
    );
    this.pregunta4SrvPantalla = new AssistanceCaseQuestions(
      '4. Jefe de Tienda'
    );
    this.pregunta5SrvPantalla = new AssistanceCaseQuestions(
      '5. No. de telefono Jefe de Tienda'
    );
    this.pregunta6SrvPantalla = new AssistanceCaseQuestions(
      '6. Costo de la Asistencia '
    );
    this.pregunta7SrvPantalla = new AssistanceCaseQuestions(
      '7. Articulo (Tv, Celular, Etc)'
    );
    this.pregunta8SrvPantalla = new AssistanceCaseQuestions('8. Marca');
    this.pregunta9SrvPantalla = new AssistanceCaseQuestions('9. Modelo');
    this.pregunta10SrvPantalla = new AssistanceCaseQuestions('10. Serie');
    this.pregunta11SrvPantalla = new AssistanceCaseQuestions(
      '11. Factura de Compra Número'
    );
    this.pregunta12SrvPantalla = new AssistanceCaseQuestions(
      '12. Precio del Equipo (PRECIO DE CONTADO)'
    );
    this.pregunta13SrvPantalla = new AssistanceCaseQuestions(
      '13. Fecha de venta de la asistencia'
    );
    this.pregunta14SrvPantalla = new AssistanceCaseQuestions(
      '14. Fecha del reclamo'
    );
    this.pregunta15SrvPantalla = new AssistanceCaseQuestions(
      '15. Observaciones (Daño del Equipo)'
    );
    this.pregunta16SrvPantalla = new AssistanceCaseQuestions(
      '16. Titular de la Asistencia'
    );
    this.pregunta17SrvPantalla = new AssistanceCaseQuestions(
      '17. Número de Identidad'
    );
    this.pregunta18SrvPantalla = new AssistanceCaseQuestions(
      '18. No. de telefono titular'
    );
    this.pregunta19SrvPantalla = new AssistanceCaseQuestions(
      '19. Número de caso (Token)'
    );
    this.pregunta20SrvPantalla = new AssistanceCaseQuestions('20. IMEI');
    this.pregunta21SrvPantalla = new AssistanceCaseQuestions(
      '21. Nombre de reportarte'
    );

    /**************************Citas presenciales********************/
    this.pregunta1CitasPresenciales = new AssistanceCaseQuestions(
      '1. Fecha de activación'
    );
    this.pregunta2CitasPresenciales = new AssistanceCaseQuestions(
      '2. Reportante'
    );
    this.pregunta3CitasPresenciales = new AssistanceCaseQuestions(
      '3. Nombre del paciente'
    );
    this.pregunta4CitasPresenciales = new AssistanceCaseQuestions(
      '4. Sintomas / Motivo de la consulta  '
    );
    this.pregunta5CitasPresenciales = new AssistanceCaseQuestions(
      '5. Edad del paciente'
    );
    this.pregunta6CitasPresenciales = new AssistanceCaseQuestions(
      '6. Parentesco'
    );
    this.pregunta7CitasPresenciales = new AssistanceCaseQuestions(
      '7. Fecha de nacimiento del paciente'
    );
    this.pregunta8CitasPresenciales = new AssistanceCaseQuestions(
      '8. ID del paciente (SI APLICA)'
    );
    this.pregunta9CitasPresenciales = new AssistanceCaseQuestions(
      '9. Horario de la cita ( AM / PM)'
    );
    this.pregunta10CitasPresenciales = new AssistanceCaseQuestions(
      '10. Correo Electronico'
    );

    /**************************Laboratorios********************/
    this.pregunta1Laboratorios = new AssistanceCaseQuestions(
      '1. Fecha de activación'
    );
    this.pregunta2Laboratorios = new AssistanceCaseQuestions('2. Reportante');
    this.pregunta3Laboratorios = new AssistanceCaseQuestions(
      '3. Nombre del paciente'
    );
    this.pregunta4Laboratorios = new AssistanceCaseQuestions(
      '4. ID del paciente'
    );
    this.pregunta5Laboratorios = new AssistanceCaseQuestions('5. Parentesco');
    this.pregunta6Laboratorios = new AssistanceCaseQuestions(
      '6. Edad del paciente'
    );
    this.pregunta7Laboratorios = new AssistanceCaseQuestions(
      '7. Fecha de nacimiento paciente'
    );
    this.pregunta8Laboratorios = new AssistanceCaseQuestions('8. Sintomas');
    this.pregunta9Laboratorios = new AssistanceCaseQuestions(
      '9. Estudio de laboratorio/imagen diagnostica que necesita'
    );
    this.pregunta10Laboratorios = new AssistanceCaseQuestions(
      '10. ¿Cuenta con orden médica para realizar los examenes/imagen diagnostica?'
    );
    this.pregunta11Laboratorios = new AssistanceCaseQuestions(
      '11. Horario de la cita AM / PM'
    );
    this.pregunta12Laboratorios = new AssistanceCaseQuestions(
      '12. Correo Electronico'
    );

    /**************************Siniestro Vial********************/
    this.pregunta1SiniestroVial = new AssistanceCaseQuestions(
      '1. ¿Quién era la persona que conducía al momento del percance?'
    );
    this.pregunta2SiniestroVial = new AssistanceCaseQuestions(
      '2. ¿Está tránsito en el lugar?'
    );
    this.pregunta5SiniestroVial = new AssistanceCaseQuestions(
      '3. ¿Hay otra persona involucrada en el accidente?'
    );
    this.pregunta6SiniestroVial = new AssistanceCaseQuestions(
      '4. Cantidad de personas lesionadas'
    );
    this.pregunta8SiniestroVial = new AssistanceCaseQuestions(
      'Comentarios iniciales del siniestro'
    );

    /************************** Servicios Nutricional ********************/
    this.pregunta1Nutricional = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2Nutricional = new AssistanceCaseQuestions(
      '2. Nombre del paciente'
    );
    this.pregunta3Nutricional = new AssistanceCaseQuestions(
      '3. ¿Parentesco con el titular?'
    );
    this.pregunta4Nutricional = new AssistanceCaseQuestions(
      '4. Edad del paciente'
    );
    this.pregunta5Nutricional = new AssistanceCaseQuestions(
      '5. Fecha de nacimiento del paciente'
    );
    this.pregunta6Nutricional = new AssistanceCaseQuestions(
      '6. ID del paciente'
    );
    this.pregunta7Nutricional = new AssistanceCaseQuestions(
      '7. Horario de la cita (AM / PM)'
    );
    this.pregunta8Nutricional = new AssistanceCaseQuestions(
      '8. Fecha de activación de sistema'
    );

    /************************** Servicios Traslado Médico ********************/
    this.pregunta1MedicalTransfer = new AssistanceCaseQuestions(
      '1. ¿El reportante se encuentra con el paciente?'
    );
    this.pregunta2MedicalTransfer = new AssistanceCaseQuestions(
      '2. ¿Cuál es la emergencia?'
    );
    this.pregunta3MedicalTransfer = new AssistanceCaseQuestions(
      '3. ¿Parentesco?'
    );
    this.pregunta4MedicalTransfer = new AssistanceCaseQuestions(
      '4. Nombre del paciente'
    );
    this.pregunta5MedicalTransfer = new AssistanceCaseQuestions(
      '5. Edad del paciente'
    );
    this.pregunta6MedicalTransfer = new AssistanceCaseQuestions(
      '6. ID del titular'
    );
    this.pregunta7MedicalTransfer = new AssistanceCaseQuestions(
      '7. Nombre del titular'
    );
    this.pregunta8MedicalTransfer = new AssistanceCaseQuestions(
      '8. Segundo número telefónico'
    );
    /************************** Servicios Traslado Médico ********************/
    this.pregunta1HeavyVehicule = new AssistanceCaseQuestions(
      '1. Cantidad de ejes '
    );
    this.pregunta2HeavyVehicule = new AssistanceCaseQuestions(
      '2. Ejes cuentan con doble rodaje/llantas cuachas'
    );
    this.pregunta3HeavyVehicule = new AssistanceCaseQuestions(
      '3. Vehículo requiere maniobras'
    );
    this.pregunta4HeavyVehicule = new AssistanceCaseQuestions(
      '4. ¿Vehículo lleva carga?'
    );
    this.pregunta5HeavyVehicule = new AssistanceCaseQuestions(
      '5. ¿Qué tipo de carga lleva?'
    );
    this.pregunta6HeavyVehicule = new AssistanceCaseQuestions('6. Otros');
    this.pregunta7HeavyVehicule = new AssistanceCaseQuestions(
      '7. Describir producto, cantidad y peso'
    );
    this.pregunta8HeavyVehicule = new AssistanceCaseQuestions(
      '8. ¿Tiempo estimado para finalizar el traslado de mercadería? '
    );

    /************************** Servicios Psicológica ********************/
    this.pregunta1Psychology = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2Psychology = new AssistanceCaseQuestions(
      '2. Nombre del paciente'
    );
    this.pregunta3Psychology = new AssistanceCaseQuestions(
      '3. ¿Parentesco con el titular?'
    );
    this.pregunta4Psychology = new AssistanceCaseQuestions(
      '4. Edad del paciente'
    );
    this.pregunta5Psychology = new AssistanceCaseQuestions(
      '5. Fecha de nacimiento del paciente'
    );
    this.pregunta6Psychology = new AssistanceCaseQuestions(
      '6. ID del paciente'
    );
    this.pregunta7Psychology = new AssistanceCaseQuestions(
      '7. Horario de la cita (AM / PM)'
    );
    this.pregunta8Psychology = new AssistanceCaseQuestions(
      '8. Fecha de activación de sistema'
    );
    /************************** Servicios Tecnológico ********************/
    this.pregunta1Technological = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2Technological = new AssistanceCaseQuestions(
      '2. ¿Nombre del solicitante?'
    );
    this.pregunta3Technological = new AssistanceCaseQuestions(
      '3. ¿Parentesco con el titular?'
    );
    this.pregunta4Technological = new AssistanceCaseQuestions(
      '4. Edad del solicitante'
    );
    this.pregunta5Technological = new AssistanceCaseQuestions(
      '5. Fecha de activación de sistema'
    );
    /************************** Servicios Legal ********************/
    this.pregunta1Legal = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2Legal = new AssistanceCaseQuestions(
      '2. ¿Nombre del solicitante?'
    );
    this.pregunta3Legal = new AssistanceCaseQuestions(
      '3. ¿Parentesco con el titular?'
    );
    this.pregunta4Legal = new AssistanceCaseQuestions(
      '4. Edad del solicitante'
    );
    this.pregunta5Legal = new AssistanceCaseQuestions(
      '5. Fecha de activación de sistema'
    );
    /************************** Servicios Ama ********************/
    this.pregunta1Ama = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2Ama = new AssistanceCaseQuestions('2. Nombre del paciente');
    this.pregunta3Ama = new AssistanceCaseQuestions(
      '3. ¿Parentesco con el titular?'
    );
    this.pregunta4Ama = new AssistanceCaseQuestions('4. Edad del paciente');
    this.pregunta5Ama = new AssistanceCaseQuestions(
      '5. Fecha de nacimiento del paciente'
    );
    this.pregunta6Ama = new AssistanceCaseQuestions(
      '6. Fecha de activación de sistema'
    );
    /************************** Servicios Dental ********************/
    this.pregunta1Dental = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2Dental = new AssistanceCaseQuestions(
      '2. Nombre del paciente'
    );
    this.pregunta3Dental = new AssistanceCaseQuestions(
      '3. ¿Parentesco con el titular?'
    );
    this.pregunta4Dental = new AssistanceCaseQuestions('4. Edad del paciente');
    this.pregunta5Dental = new AssistanceCaseQuestions('5. ID del paciente');
    this.pregunta6Dental = new AssistanceCaseQuestions(
      '6. Fecha de nacimiento del paciente'
    );
    this.pregunta7Dental = new AssistanceCaseQuestions(
      '7. Horario de la cita (AM / PM)'
    );
    this.pregunta8Dental = new AssistanceCaseQuestions(
      '8. Fecha de activación de sistema'
    );
    this.pregunta9Dental = new AssistanceCaseQuestions('9. Correo Electronico');
    /************************** Servicios Veterinaria Ambulancia ********************/
    this.pregunta1VetAmbulancia = new AssistanceCaseQuestions(
      '1. ¿Cuál es la emergencia?'
    );
    this.pregunta2VetAmbulancia = new AssistanceCaseQuestions(
      '2. Nombre de la mascota'
    );
    this.pregunta3VetAmbulancia = new AssistanceCaseQuestions('3. Raza');
    this.pregunta4VetAmbulancia = new AssistanceCaseQuestions(
      '4. Edad de la mascota'
    );
    this.pregunta5VetAmbulancia = new AssistanceCaseQuestions(
      '5. Peso de la mascota'
    );
    this.pregunta6VetAmbulancia = new AssistanceCaseQuestions(
      '6. Fecha de activación de sistema'
    );
    /************************** Servicios Veterinaria Visita Domiciliar ********************/
    this.pregunta1VetVistD = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2VetVistD = new AssistanceCaseQuestions(
      '2. Nombre de la mascota'
    );
    this.pregunta3VetVistD = new AssistanceCaseQuestions('3. Raza');
    this.pregunta4VetVistD = new AssistanceCaseQuestions(
      '4. Edad de la mascota'
    );
    this.pregunta5VetVistD = new AssistanceCaseQuestions(
      '5. Peso de la mascota'
    );
    this.pregunta6VetVistD = new AssistanceCaseQuestions(
      '6. Horario de la cita (AM / PM)'
    );
    this.pregunta7VetVistD = new AssistanceCaseQuestions(
      '7. Fecha de activación de sistema'
    );
    this.pregunta8VetVistD = new AssistanceCaseQuestions(
      '8. Correo Electronico'
    );
    /************************** Servicios Veterinaria Visita a Clinica ********************/
    this.pregunta1VetVistC = new AssistanceCaseQuestions(
      '1. ¿Cuál es el motivo de la consulta?'
    );
    this.pregunta2VetVistC = new AssistanceCaseQuestions(
      '2. Nombre de la mascota'
    );
    this.pregunta3VetVistC = new AssistanceCaseQuestions('3. Raza');
    this.pregunta4VetVistC = new AssistanceCaseQuestions(
      '4. Edad de la mascota'
    );
    this.pregunta5VetVistC = new AssistanceCaseQuestions(
      '5. Peso de la mascota'
    );
    this.pregunta6VetVistC = new AssistanceCaseQuestions(
      '6. Horario de la cita (AM / PM)'
    );
    this.pregunta7VetVistC = new AssistanceCaseQuestions(
      '7. Fecha de activación de sistema'
    );
    this.pregunta8VetVistC = new AssistanceCaseQuestions(
      '8. Correo Electronico'
    );
  }

  getFastService(plan_id) {
    this.fastServices1 = [];
    this.fastServices2 = [];

    this.api.assistancecases
      .fastServices()
      .params({ plan_id: plan_id })
      .promise()
      .then((r) => {
        let subtotal = r.data.length;
        let extras = 5 - subtotal;
        let extra = {
          description: '',
          equivalence2_: '0',
          // equivalence3_: "",
          equivalence_: '0',
          from_: '',
          grouper_: '',
          id: 0,
          to_: '',
          value_: '',
        };
        for (let i = 0; i < extras; i++) {
          r.data.push(extra);
        }
        for (let i = 0; i < r.data.length; i++) {
          const element = r.data[i];
          if (i < 4) {
            this.fastServices1.push(element);
          } else {
            this.fastServices2.push(element);
          }
        }
      });
  }

  resetNums() {
    this.areAmountsVisible = false;
    this.maxAssistancesReached = false;
    this.waitingTimeFulfilledService = true;
    this.remaining_assistances = null;
    this.courtesy_assistances = null;
    this.used_services = null;
    this.total_cases = null;
    this.is_on_waiting_period = false;
    this.intime = null;
    this.in_use = null;
    this.consumido = null;
    this.disponible = null;
  }

  async onSelectCategory(category_id) {
    this.resetNums();
    if (category_id) {
      this.selectCategory_id = parseInt(category_id);
      this.editcategory = _.find(
        this.assistancecategories,
        (p) => p.id == this.selectCategory_id
      );

      if (!this.assistancecase) {
        if (this.editcategory.name.toLowerCase().indexOf('vial') >= 0) {
          this.loaderService.display(true);

          await this.api.carBrands
            .getAll()
            .all()
            .promise()
            .then((b) => {
              this.carbrands = b.data;
            })
            .catch((error) => { });

          this.loaderService.display(false);

          this.showcarflag = true;

          if (this.assistancecase.assistance_sale_id) {
            // when has sale_id, auto select car
            this.api.assistancesales
              .getbyId(this.assistancecase.assistance_sale_id)
              .promise()
              .then((sale) => {
                const case_sale = sale;
                if (case_sale.assistance_sale_car.length > 0) {
                  const saleCar = case_sale.assistance_sale_car[0];
                  
                  this.editticket.brand_description = saleCar.brand_description;
                  this.editticket.model_description = saleCar.model_description;
                  
                  this.editticket.car_model = saleCar.car_model_name;

                  this.editticket.car_year =
                    case_sale.assistance_sale_car[0].car_year;
                  this.selectYear = case_sale.assistance_sale_car[0].car_year;
                  this.editticket.color_description =
                    case_sale.assistance_sale_car[0].color_description;
                  this.editticket.car_color_name =
                    case_sale.assistance_sale_car[0].color_description;
                  this.editticket.car_color =
                    case_sale.assistance_sale_car[0].car_color;
                  this.editticket.car_plate =
                    case_sale.assistance_sale_car[0].car_plate;
                }
              })
              .catch((error) => { });
          }
          await this.api.assistanceserviceCategoryProduct
            .get(this.selectCategory_id, this.assistancecase.id)
            .promise()
            .then((s) => {
              this.services = s.data;
            });
        } else {
          this.showcarflag = false;
        }
        this.api.assistanceserviceCategoryProduct
          .get(this.selectCategory_id, this.assistancecase.id)
          .promise()
          .then((s) => {
            this.services = s.data;
          });
      } else {
        // No assistance case
        if (this.editcategory.name.toLowerCase().indexOf('vial') >= 0) {
          this.loaderService.display(true);

          await this.api.carBrands

            .getAll()
            .all()
            .promise()
            .then((b) => {
              this.carbrands = b.data;
            })
            .catch((error) => { });

          this.loaderService.display(false);

          this.showcarflag = true;

          if (this.selectedSale) {
            // when has sale_id, auto select car
            this.api.assistancesales
              .getbyId(this.selectedSale.id)
              .promise()
              .then((sale) => {
                const case_sale = sale;
                if (case_sale.assistance_sale_car.length > 0) {
                  const saleCar = case_sale.assistance_sale_car[0];
                  
                  this.editticket.brand_description = saleCar.brand_description;
                  this.editticket.model_description = saleCar.model_description;
                  
                  this.editticket.car_model = saleCar.car_model_name;
                  this.editticket.car_year =
                    case_sale.assistance_sale_car[0].car_year;
                  this.selectYear = case_sale.assistance_sale_car[0].car_year;
                  this.editticket.color_description =
                    case_sale.assistance_sale_car[0].color_description;
                  this.editticket.car_color_name =
                    case_sale.assistance_sale_car[0].color_description;
                  this.editticket.car_color =
                    case_sale.assistance_sale_car[0].car_color;
                  this.editticket.car_plate =
                    case_sale.assistance_sale_car[0].car_plate;

                  this.selectedVehicleId = case_sale.assistance_sale_car[0].id;

                  this.vehicles = this.getVehicles(
                    case_sale.assistance_sale_car
                  );
                }
              })
              .catch((error) => { });
          }

          if (this.sale && this.sale.plan.addons.length > 0) {
            await this.api.assistanceserviceCategoryProductPlan2
              .get(this.selectCategory_id, this.plan_id, this.sale.id)
              .promise()
              .then((s) => {
                this.services = s.data;
              });
          } else {
            await this.api.assistanceserviceCategoryProductPlan
              .get(this.selectCategory_id, this.plan_id)
              .promise()
              .then((s) => {
                this.services = s.data;
              });
          }
        } else {
          this.showcarflag = false;
        }
        if (this.sale && this.sale.plan.addons.length > 0) {
          this.api.assistanceserviceCategoryProductPlan2
            .get(this.selectCategory_id, this.plan_id, this.sale.id)
            .promise()
            .then((s) => {
              this.services = s.data;
            });
        } else {
          this.api.assistanceserviceCategoryProductPlan
            .get(this.selectCategory_id, this.plan_id)
            .promise()
            .then((s) => {
              this.services = s.data;
            });
        }
      }
    } else {
      this.services = [];
      this.showcarflag = false;
    }
    this.editticket.service_id = null;
    this.editservice = new AssistanceService();
  }

  addEditCar() {
    this.api.assistancesales
      .getbyId(this.selectedSale.id)
      .promise()
      .then((sale) => {
        if (sale.assistance_sale_car[0] != undefined) {
          this.car_of_assistance = sale.assistance_sale_car[0];
        } else {
          this.car_of_assistance = new CarModelSinister();
        }
      });
  }

  onSelectBrand(brand_id_select, defaultSelect = false, value = '') {
    this.clearCarModelSelection();

    let paramNameModel = {
      nameModel: value,
    };

    if (brand_id_select) {
      const selectedBrand = this.carbrands.find(b => b.id == brand_id_select);
      if (selectedBrand) {
        this.editticket.brand_description = selectedBrand.name;
      }

      this.loaderService.display(true);
      this.api.carBrands
        .getModels(brand_id_select)
        .params(paramNameModel)
        .all()
        .promise()
        .then((models) => {
          this.loaderService.display(false);
          this.carmodels = models;

          if (defaultSelect) {
            this.selectModel_id = this.carmodels.find(
              (element) =>
                element.name.toString().trim().toUpperCase() ==
                value.toString().trim().toUpperCase()
            ).id;
          }
        })
        .catch((error) => {
          this.loaderService.display(false);
        });
    }
  }

  onSelectModel(model_id) {
    if (model_id) {
      let carmodel = _.find(this.carmodels, (p) => p.id == model_id);

      if (carmodel) {
        this.editticket.model_description = carmodel.name;
        this.editticket.car_model = carmodel.name;
      }
    } else {
      this.editticket.model_description = null;
      this.editticket.car_model = null;
    }
  }

  onSelectYear(year) {
    if (year) {
      this.editticket.car_year = parseInt(year);
    } else {
      this.editticket.car_year = null;
    }
  }

  onSelectColor(color) {
    if (color) {
      this.editticket.color_description = color;
      this.editticket.car_color_name = color;
    } else {
      this.editticket.color_description = null;
      this.editticket.car_color_name = null;
    }
  }

  async onSelectService(service_id) {
    await this.getQuestions(service_id);
    this.serviceSelected = service_id;
    this.resetNums();

    // TEMPORAL Valida si existe la sale realizará este flujo
    // Pendiente de revisión de boletas manuales del proyecto SDS
    if (this.sale) {
      const temp_serv = _.find(this.services, (p) => p.id == service_id);

      if (this.sale.category == 'BUCA INSURANCE') {
        this.buca_plan = true;
        let response_amount = await this.api.buca
          .getPolicyAmountInfo(this.sale.code, this.sale.member.id)
          .promise();
        if (response_amount) {
          this.buca_max_amount = response_amount.max_amount.toFixed(2);
          this.buca_amount_available =
            response_amount.amount_available.toFixed(2);
          this.buca_currency = response_amount.currency_code;
          if (
            this.buca_amount_available <= 100 &&
            this.buca_amount_available > 0
          ) {
            this.max_amount_flag = true;
          }

          if (this.buca_amount_available <= 0) {
            this.max_amount_available_flag = true;
          }
        }
      }
    }

    if (service_id) {
      this.messages = [];
      this.editservice = _.find(this.services, (p) => p.id == service_id);

      if (!this.editservice) {
        this.api.assistanceserviceById
          .get(service_id)
          .promise()
          .then((data) => {
            this.editservice = data;
          })
          .catch((e) => { });
      }

      this.editticket.service_id = parseInt(service_id);

      if (!this.assistancecase) {
        this.api.assistanceplanAmount
          .get(service_id, this.assistancecase.id)
          .promise()
          .then((data) => {
            this.areAmountsVisible = true;
            this.remaining_assistances = data.remaining_assistances;
            this.courtesy_assistances = data.courtesy_assistances;
            this.inperiod_assistances = data.inperiod_assistances;
            this.intime = data.used_services2;
            this.in_use = data.in_use;

            this.pass = data.pass;

            this.used_services = data.used_services;
            this.total_cases = data.total_cases;
            this.is_on_waiting_period = data.on_waiting_period;

            if (data.in_use > 0) {
              this.in_use_flag = true;
            }

            if (
              this.remaining_assistances !== undefined &&
              this.remaining_assistances <= 0
            ) {
              // Only offer by connection
              this.maxAssistancesReached = true;
              //this.onSelectConnection(1);
            } else if (this.is_on_waiting_period) {
              this.waitingTimeFulfilledService = false;
              //this.onSelectConnection(1);
            }
          })
          .catch((e) => {
            this.translate
              .get('Unable to get service for sale information')
              .subscribe((res: string) => {
                this.messages.push({
                  severity: 'error',
                  summary: 'Error',
                  detail: `${res}: ${e.error}`,
                });
              });
          });
      } else {
        console.log("AHHHHHHHHHH", this.selectedSale, this.assistancecase.member_id)
        this.api.assistanceplanAmount
          .getByPlan(
            service_id,
            this.plan_id,
            this.selectedSale ? this.selectedSale.id : null,
            this.assistancecase.member_id
          )
          .promise()
          .then((data) => {
            this.areAmountsVisible = true;
            this.remaining_assistances = data.remaining_assistances;
            this.used_services = data.used_services;
            this.total_cases = data.total_cases;
            this.courtesy_assistances = data.courtesy_assistances;
            this.is_on_waiting_period = data.on_waiting_period;
            this.in_use = data.in_use;

            if (data.in_use > 0) {
              if (this.sale) {
                if (
                  !this.editcategory.code_equivalence ||
                  (this.sale.plan.sinister_plan != 1 &&
                    this.editcategory.code_equivalence !=
                    TYPE_CATEGORY.TYPE_ROAD)
                ) {
                  this.in_use_flag = true;
                }
              }
            }

            if (
              this.remaining_assistances !== undefined &&
              this.remaining_assistances <= 0
            ) {
              // Only offer by connection
              this.maxAssistancesReached = true;
              //this.onSelectConnection(1);
            } else if (this.is_on_waiting_period) {
              this.waitingTimeFulfilledService = false;
              //this.onSelectConnection(1);
            }
          })
          .catch((e) => {
            this.translate
              .get('Unable to get service for sale information')
              .subscribe((res: string) => {
                this.messages.push({
                  severity: 'error',
                  summary: 'Error',
                  detail: `${res}: ${e.error}`,
                });
              });
          });
      }
      await this.extrainfo(service_id);
      const temp_serv = _.find(this.services, (p) => p.id == service_id);
      if (this.additionalplanservice.sinister_apply == 1) {
        if (
          temp_serv?.category?.code_equivalence == TYPE_CATEGORY.TYPE_ROAD
        ) {
          this.addEditCar();
        } else {
          if (this.sale) {
            this.api.assistancesales
              .getSinistersFromSale(this.sale.id)
              .promise()
              .then((sinisters) => {
                if (sinisters.length > 0) {
                  this.hasSinisters = true;
                  this.sinisterList = sinisters;
                }
              })
              .catch((error) => { });
          }
        }
      }
    } else {
      this.editticket.service_id = null;
      this.editservice = null;
    }
  }

  onHideActiveService() {
    this.in_use_flag = false;
    if (this.additionalplanservice.sinister_apply == 1) {
      this.serviceSelected = null;
      this.editticket.service_id = null;
      this.editservice = null;
    }
  }

  async extrainfo2(idservice, max) {
    try {
      const filter2 = {
        plan_id: this.plan_id,
        service_id: idservice,
        total: max,
      };

      await this.api.assistanceplanservices
        .get_operations12()
        .filter(filter2)
        .promise()
        .then((data) => {
          this.consumido = data[0]['consumido'];
          this.disponible = data[0]['disponible'];
        });
    } catch (exception) { }
  }
  async extrainfo(idservice) {
    const filter = { plan_id: this.plan_id, service_id: idservice };
    await this.api.assistanceplanservices
      .get_extrainfo()
      .filter(filter)
      .promise()
      .then((data) => {
        this.additionalplanservice.emergency_reporting_time =
          data[0].emergency_reporting_time;
        this.additionalplanservice.territoriality = data[0].territoriality;

        this.additionalplanservice.special_condition =
          data[0].special_condition;
        this.additionalplanservice.sinister_apply =
          data[0].sinister_apply;

        if (
          this.additionalplanservice.special_condition &&
          this.noSpecialPlans &&
          this.plan_id != this.noSpecialPlans.equivalence_ &&
          this.plan_id != this.noSpecialPlans.equivalence2_
        ) {
          this.translate
            .get('Check special conditions')
            .subscribe((res: string) => {
              this.messageService.add({
                severity: 'warn',
                life: 60000,
                summary: 'Aviso',
                detail: res,
              });
            });
        }

        this.additionalplanservice.max_amount_general =
          data[0].max_amount_general || 0;
        this.additionalplanservice.buca_apply =
          data[0].buca_apply || 0;
        this.additionalplanservice.sinister_apply =
          data[0].sinister_apply || 0;
      });

    this.extrainfo2(idservice, this.additionalplanservice.max_amount_general);
  }

  onSelectProgram(value) {
    this.programmed = value;
    if (this.programmed === 1) {
      this.editticket.programmed = 1;
    } else this.editticket.programmed = null;
    this.fieldsRequired['programdate'] = false;
    this.editticket.programdate = new Date();
    this.programtime = new Date().getHours() + ':' + new Date().getMinutes();
  }

  onSelectday(date) {
    if (date === null) {
      this.fieldsRequired['programdate'] = true;
    } else {
      const set_date = date + ' ' + this.programtime;
      this.editticket.programdate = moment(set_date).toDate();
      this.fieldsRequired['programdate'] = false;
    }
  }

  onSelectTime() {
    const set_date =
      this.editticket.programdate.toDateString() + ' ' + this.programtime;
    this.editticket.programdate = moment(set_date).toDate();
  }

  onSelectConnection(value) {
    this.connection = value;
    this.editticket.connection = value;
  }

  onSelectProgramType(event) {
    let value = event.target.value;
    this.program_type = +value || null;
    this.editticket.program_type = +value || null;

    this.onSelectProgramSubType(value);
  }

  step1SetLocation(location) {
    this.editticket.latitude = location.latitude;
    this.editticket.longitude = location.longitude;

    const coordinates = {
      latitude: location.latitude,
      longitude: location.longitude,
    };

    this.api.assistancecases
      .get_geolocation_by_coordinates(coordinates)
      .post()
      .promise()
      .then((resp) => {
        setTimeout(() => {
          if (resp.result) {
            this.google_address_destination = resp.complete_address;
            this.editticket.address_destination = this.editticket
              .address_destination
              ? this.editticket.address_destination
              : resp.complete_address;
            this.editticket.area_destination = this.editticket.area_destination
              ? this.editticket.area_destination
              : resp.mayoralty;
            this.editticket.suburb_destination = this.editticket
              .suburb_destination
              ? this.editticket.suburb_destination
              : resp.neighborhood;
            this.editticket.street_destination = this.editticket
              .street_destination
              ? this.editticket.street_destination
              : resp.street_number;
            this.editticket.postal_code_destination = resp.postal_code
              ? resp.postal_code
              : '00000';

            if (
              this.caseForm &&
              this.caseForm.form &&
              this.caseForm.form.controls
            ) {
              this.caseForm.form.controls.address_destination.patchValue(
                this.editticket.address_destination
              );
              this.caseForm.form.controls.suburb_destination.patchValue(
                this.editticket.suburb_destination
              );
              this.caseForm.form.controls.street_destination.patchValue(
                this.editticket.street_destination
              );
              this.caseForm.form.controls.postal_code_destination.patchValue(
                this.editticket.postal_code_destination
              );
            }
          }
        }, 1);
      })
      .catch((e) => {
        this.createAddressDestination();
      });
  }

  step1SelectMap() {
    if (this.assistancecase.country.locale.length > 2) {
      this.assistancecase.country.locale = this.assistancecase.country.locale
        .split('-')[1]
        .toLowerCase();
    }

    this.showMap.emit(true);
  }

  async onSubmit() {
    if (
      this.buca_amount_available <= 0 &&
      this.editticket.connection != 1 &&
      this.buca_plan
    ) {
      this.translate
        .get('You must select a service by connection')
        .subscribe((res: string) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: res,
          });
        });
      return;
    }
    if (!this.serviceSelected || this.serviceSelected == -1) {
      this.translate
        .get('You must select a service please')
        .subscribe((res: string) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: res,
          });
        });
      return;
    }
    if (this.respuestaGiraLlantas == 'No') {
      const respuesta1 = document.getElementById(
        'respuestallantadelanteraizquierda'
      ) as HTMLInputElement | null;
      const respuesta2 = document.getElementById(
        'respuestaLlantadelanteraderecha'
      ) as HTMLInputElement | null;
      const respuesta3 = document.getElementById(
        'respuestaLlantatraseraizquierda'
      ) as HTMLInputElement | null;
      const respuesta4 = document.getElementById(
        'respuestaLlantatraseraderecha'
      ) as HTMLInputElement | null;
      if (
        respuesta1.checked == false &&
        respuesta2.checked == false &&
        respuesta3.checked == false &&
        respuesta4.checked == false
      ) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Debes indicar que llanta(s) no gira(n)',
        });
        return;
      }
    }

    if (this.maxAssistancesReached && this.editticket.connection != 1) {
      this.translate
        .get(
          'You do not have assistance available, please select service by Total Cost'
        )
        .subscribe((res: string) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: res,
          });
        });
      return;
    }

    if (!this.waitingTimeFulfilledService && this.editticket.connection != 1) {
      this.translate
        .get(
          'The waiting time for the service has not been completed, please select service by Total Cost'
        )
        .subscribe((res: string) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: res,
          });
        });
      return;
    }
    if (this.editticket.car_plate) {
      this.editticket.car_plate = this.editticket.car_plate.trim();
    }

    // if (TYPE_SERVICES.TYPE_TRUCK != this.serviceSelected) {
    let destinationServices = [
      TYPE_SERVICES.TYPE_TRUCK,
      TYPE_SERVICES.TYPE_TAXI,
      TYPE_SERVICES.TYPE_TAXI_AIRPORT,
      TYPE_SERVICES.TYPE_REPATRIATION,
      TYPE_SERVICES.TYPE_TRUCK_MOTORCYCLE,
      TYPE_SERVICES.TYPE_LOCKSMITH_VEHICLE_INSURED,
      TYPE_SERVICES.TYPE_TIRE_CHANGE_VEHICLE_INSURED,
      TYPE_SERVICES.TYPE_GASOLINE_VEHICLE_INSURED,
      TYPE_SERVICES.TYPE_CURRENT_FLOW_VEHICLE_INSURED,
      TYPE_SERVICES.TYPE_TRUCK_VEHICLE_INSURED,
    ];
    let answers = [];
    this.questions.forEach((question) => {
      let answer = {};
      if (question.answer_text) {
        answer['answer_text'] = question.answer_text;
      }
      if (question.option_selected_id) {
        answer['option_selected_id'] = question.option_selected_id;
      }
      if (
        question.question.type_ === this.QUESTION_TYPE.TYPE_NUMBER.id &&
        question.answer_text == 0
      ) {
        answer['answer_text'] = 0;
      }
      answer['question_id'] = question.question.id;
      answers.push(answer);
    });
    this.editticket.answers = answers;
    // Concat destination for Ambulance services
    destinationServices = destinationServices.concat(this.ambulance_id);
    if (destinationServices.indexOf(+this.serviceSelected) == -1) {
      this.editticket.state_id = this.assistancecase.state_id;
      this.editticket.state_area_id = this.assistancecase.state_district_id;
      this.editticket.area_destination = this.assistancecase.area;
      this.editticket.postal_code_destination = this.assistancecase.postal_code;
      this.editticket.street_destination = this.assistancecase.street;
      this.editticket.zone_destination = this.assistancecase.zone;
      this.editticket.suburb_destination = this.assistancecase.suburb;
      this.editticket.latitude = this.editLocation.latitude;
      this.editticket.longitude = this.editLocation.longitude;
      this.editticket.address_destination = this.assistancecase.address;
    }

    this.createCurrentAddress();
    this.createAddressDestination();
    this.onSelectYear(this.selectYear);
    this.editticket.ticket_type = 1;

    if (this.editticket.brand_description) {
      this.editticket.car_brand = this.editticket.brand_description;
    }
    if (this.editticket.model_description) {
      this.editticket.car_model = this.editticket.model_description;
    }

    this.editticket.car_of_assistance = this.car_of_assistance;
    this.editticket.comment = this.comment;

    let member = this.assistancecase.member;
    if (this.sale) {
      this.assistancecase.customer_first_name = this.sale.PrimerNombre
        ? this.sale.PrimerNombre
        : null;
      this.assistancecase.customer_middle_name = this.sale.SegundoNombre
        ? this.sale.SegundoNombre
        : null;
      this.assistancecase.customer_last_name = this.sale.ApellidoPaterno
        ? this.sale.ApellidoPaterno
        : null;
      this.assistancecase.customer_last_name_2 = this.sale.ApellidoMaterno
        ? this.sale.ApellidoMaterno
        : null;
      this.assistancecase.business_name = this.sale.razonSocial
        ? this.sale.razonSocial
        : null;
    } else {
      this.assistancecase.customer_first_name =
        this.assistancecase.contact_name;
    }

    member.country = this.country.id;
    if (this.member) {
      member.national_id = this.member.national_id;
    } else {
      member.national_id = this.member_national_id;
      member.first_name = this.assistancecase.contact_name;
      member.name = this.assistancecase.contact_name;
      member.phone1 = '0';
      member.last_name = '.';
    }
    this.assistancecase.postal_code =
      this.assistancecase.postal_code.toString();

    if (this.sinisterList.length > 0) {
      this.assistancecase.sds_sinister_claim_id = this.selectedSinister
        ? this.selectedSinister
        : null;
    }

    if (
      this.typeSearch == this.TYPE_SEARCH.BY_CONECTION ||
      this.typeSearch == this.TYPE_SEARCH.MANUAL_CASE
    ) {
    } else {
      this.assistancecase.member = null;
    }
    //this.assistancecase.member = null;
    if (
      this.stopLightNumber == 0 &&
      this.ambulance_id.indexOf(this.editticket.service_id) >= 0
    ) {
    } else {
      this.saveAsistanceCase(this.editticket, member);
    }
  }

  createCurrentAddress() {
    if (!this.assistancecase.address) {
      this.assistancecase.address = `${this.assistancecase.area || ''} ${this.assistancecase.postal_code || ''
        } ${this.assistancecase.street || ''} ${this.assistancecase.zone || ''} ${this.assistancecase.suburb || ''
        }`;
    } else if (this.google_address_origen != '') {
      this.assistancecase.address =
        this.assistancecase.address + ` (${this.google_address_origen})`;
      this.caseForm.form.controls.assistancecase_address.patchValue(
        this.assistancecase.address
      );
    }
  }

  createAddressDestination() {
    if (!this.editticket.address_destination) {
      this.editticket.address_destination = `${this.editticket.area_destination || ''
        } ${this.editticket.postal_code_destination || ''} ${this.editticket.street_destination || ''
        } ${this.editticket.zone_destination || ''} ${this.editticket.suburb_destination || ''
        }`;
    } else if (this.google_address_destination != '') {
      this.editticket.address_destination =
        this.editticket.address_destination +
        ` (${this.google_address_destination})`;
      this.caseForm.form.controls.address_destination.patchValue(
        this.editticket.address_destination
      );
    }
  }

  onSelectStateTicket(state_id) {
    this.editticket.state_area_id = null;
    if (state_id) {
      const filter = { state_id: state_id };
      this.api.statedistricts
        .get()
        .filter(filter)
        .promise()
        .then((d) => {
          this.statesDistrictTicket = d.data;
        });
    } else {
      this.statesDistrictTicket = [];
    }
  }

  // ** TICKET

  ngOnChanges(changes: any) {
    if (changes.assistancecase && changes.assistancecase.currentValue) {
      this.editLocation.latitude = changes.assistancecase.currentValue.latitude;
      this.editLocation.longitude =
        changes.assistancecase.currentValue.longitude;
      if (changes.assistancecase.currentValue.member_id) {
        const filter_assistance = {
          status: 1,
          country_id: changes.assistancecase.currentValue.member.country,
        };

        this.api.assistances
          .get()
          .filter(filter_assistance)
          .promise()
          .then((resp) => {
            this.assistanceProducts = resp.data;
          });
      }
      if (changes.assistancecase.currentValue.state_id) {
        const filter = {
          state_id: changes.assistancecase.currentValue.state_id,
        };
        this.api.statedistricts
          .get()
          .filter(filter)
          .promise()
          .then((d) => {
            this.statesDistrict = d.data;
          });
      }
      this.country = Object.assign({}, this.assistancecase.country);
    } else {
      this.editLocation = new Location();
    }

    this.showMap.emit(true);
    this.setIsMemberDisabled();

    if (this.assistancecase.member_id) {
      this.fieldsRequired['member'] = false;
    }
    if (this.assistancecase.address) {
      this.fieldsRequired['address'] = false;
    }

    this.selectFocused.emit(true);
  }

  initfield() {
    // init product, plan, sale
    this.assistancesales = [];
    this.assistanceplans = [];
    this.assistanceProducts = [];
    this.shortProducts = [];
    this.assistancecase.assistance_id = null;
    this.assistancecase.assistance_plan_id = null;
    this.assistancecase.assistance_sale_id = null;
    this.selectedSale = null;
  }

  onSelectCountry(country_id) {
    if (country_id == 1) {
      this.PLAN_BY_CONECTION_ID = 1026;
    } else if (country_id == 2) {
      this.PLAN_BY_CONECTION_ID = 1027;
    } else if (country_id == 3) {
      this.PLAN_BY_CONECTION_ID = 1028;
    } else if (country_id == 4) {
      this.PLAN_BY_CONECTION_ID = 1029;
    } else if (country_id == 5) {
      this.PLAN_BY_CONECTION_ID = 1030;
    } else if (country_id == 7) {
      this.PLAN_BY_CONECTION_ID = 1031;
    } else if (country_id == 8) {
      this.PLAN_BY_CONECTION_ID = 1032;
    } else if (country_id == 9) {
      this.PLAN_BY_CONECTION_ID = 1033;
    } else if (country_id == 10) {
      this.PLAN_BY_CONECTION_ID = 1034;
    } else if (country_id == 11) {
      this.PLAN_BY_CONECTION_ID = 1035;
    }

    this.initfield();
    if (country_id == null) {
      this.country = new Country();
      this.states = null;
      this.statesTicket = null;
      this.assistancecase.country_id = null;
      this.assistanceProducts = null;
      this.assistancecase.assistance_id = null;
      this.sale_status = null;
      this.statesDistrict = [];
      this.assistancecase.state_district_id = null;
      this.state_text = '';
      this.state_district_text = '';
      this.showStateText = false;
      this.country_id = null;
    } else {
      this.country = _.find(this.countries, function (c) {
        return c.id === country_id;
      });

      this.destination_country = this.country;

      this.assistancecase.country_id = country_id;
      this.assistancecase.origin_country_id = country_id;
      this.assistancecase.destination_country_id = country_id;

      this.api.states
        .get(this.country.id)
        .promise()
        .then((states) => {
          this.states = states;
          this.statesTicket = states;
        });
      if (this.country.locale.length > 2) {
        this.country.locale = this.country.locale.split('-')[1].toLowerCase();
      }

      this.country_code.country_name = this.country.name;
      this.country_code.country_local = this.country.locale;
      this.country_code.iso3166_1 = this.country.iso3166_1;
      this.caseLocation = {
        latitude: null,
        longitude: null,
      };
      this.memberLocation.emit(this.country_code);
      this.memberLocationDestination.emit(this.country_code);
    }

    this.assistancecase.member_id = null;
    this.clearMember.emit(true);
    this.assistancecase.member = new Member();

    this.setIsMemberDisabled();
    if (country_id) {
      const filter = { status: 1, country_id: country_id };
      this.api.assistances
        .get()
        .filter(filter)
        .promise()
        .then((products) => (this.products = products.data));
    } else {
      this.products = [];
      this.assistanceplans = [];
    }
  }

  onSelectState(state_id) {
    this.assistancecase.state_district_id = null;

    if (state_id) {
      this.assistancecase.state_id = state_id;
      this.stateId = state_id;

      this.state = _.find(this.states, function (s) {
        return s.id === state_id;
      });
      const filter = { state_id: state_id };
      this.api.statedistricts
        .get()
        .filter(filter)
        .promise()
        .then((d) => {
          this.statesDistrict = d.data;
        });
    } else {
      this.statesDistrict = [];
    }
  }

  onSelectStateDistrict(state_district_id) {
    if (state_district_id) {
      this.assistancecase.state_district_id = parseInt(state_district_id);
    }
  }

  onSelectProductManual(product_id) {
    this.assistancecase.assistance_id = product_id;
    if (product_id) {
      const filter = {
        assistance_id: product_id,
        status: 1,
      };

      this.api.assistanceplans
        .get()
        .filter(filter)
        .promise()
        .then((resp) => {
          this.assistanceplans = resp.data;
        });
    } else {
      this.assistanceplans = [];
    }
  }

  onSelectProduct(assistance_id) {
    this.assistancesales = [];
    this.assistanceplans = [];
    this.assistancecase.assistance_plan_id = null;
    this.assistancecase.assistance_sale_id = null;
    this.selectedSale = null;

    if (assistance_id) {
      this.assistancecase.assistance_id = parseInt(assistance_id);
      let member_id = this.assistancecase.member_id;
      // if (typeof member_id == 'undefined') {
      //   member_id = 0;
      // }
      if (!member_id) {
        member_id = 0;
      }

      this.api.assistanceplans
        .getmemberplans(assistance_id, member_id)
        .promise()
        .then((resp) => {
          this.assistanceplans = resp;

          if (this.assistanceplans.length >= 1) {
            if (this.typeSearch == this.TYPE_SEARCH.COVER_LETTER) {
              //cover letter
              this.assistancecase.assistance_plan_id =
                this.assitanceCoverLetter.plan_id;
            } else if (this.typeSearch == this.TYPE_SEARCH.BY_CONECTION) {
              this.assistancecase.assistance_plan_id =
                this.assitanceByConection.plan_id;
            } else {
              this.assistancecase.assistance_plan_id =
                this.assistanceplans[0].id;
            }

            this.onSelectPlan(this.assistancecase.assistance_plan_id);
          }
        });
      this.sale_status = null;
      const delay_product = _.find(this.shortProducts, {
        id: assistance_id,
        sale_status: 2,
      });
      const cancel_product = _.find(this.shortProducts, {
        id: assistance_id,
        sale_status: 3,
      });
      const active_product = _.find(this.shortProducts, {
        id: assistance_id,
        sale_status: 1,
      });

      if (active_product) {
        this.sale_status = null;
      } else {
        if (delay_product) this.sale_status = delay_product.sale_status;
        if (cancel_product) this.sale_status = cancel_product.sale_status;
      }
    } else if (assistance_id === null) {
      this.assistancecase.assistance_id = null;
      this.sale_status = null;
    }
  }
  onSelectPlanManual(plan_id) {
    this.plan_id = parseInt(plan_id);
    this.assistancecase.assistance_plan_id = plan_id;

    this.assistanceplans.forEach((plan) => {
      if (plan.id == this.assistancecase.assistance_plan_id) {
        this.planManualSelected = plan;
        return;
      }
    });
  }
  onSelectPlan(plan_id) {
    this.assistancesales = [];
    this.assistancecase.assistance_sale_id = null;
    this.selectedSale = null;
    if (plan_id) {
      this.plan_id = parseInt(plan_id);

      if (
        this.typeSearch == this.TYPE_SEARCH.COVER_LETTER &&
        this.assitanceCoverLetter
      ) {
        this.sponsor = this.assitanceCoverLetter.sponsor;
      } else {
        this.api.assistancecases
          .getsponsor({ plan_id: this.plan_id })
          .promise()
          .then((r) => {
            this.sponsor = r;
          });
      }

      this.assistancecase.assistance_plan_id = parseInt(plan_id);
      let member_id = this.assistancecase.member_id;

      if (!member_id) {
        member_id = 0;
      }
      const filter = {
        assistance_plan_id: plan_id,
        member_id: member_id,
      };

      this.api.assistancesales
        .getSalesByMemberPlan()
        .filter(filter)
        .promise()
        .then((resp) => {
          this.assistancesales = resp;
          if (this.assistancesales.length === 1) {
            this.assistancecase.assistance_sale_id = this.assistancesales[0].id;
            this.onSelectSale(this.assistancecase.assistance_sale_id);
          }
        });

      this.getFastService(plan_id);

      this.api.assistancecategoryByPlanId
        .get(plan_id)
        .promise()
        .then((response) => {
          this.assistancecategories = response.data || [];

          if (this.saleClientSelected) {
            let message = {
              assistancecategories: this.assistancecategories,
              saleClientSelected: this.saleClientSelected,
            };

            this.editticket.car_plate = message.saleClientSelected['Placas'];
            this.editticket.vehicle_reference =
              message.saleClientSelected['DescripcionVehiculo'];
            this.selectYear = parseInt(message.saleClientSelected['Modelo']);

            const filter = {
              name: message.saleClientSelected['Marca'],
            };

            this.api.carBrands
              .search()
              .filter(filter)
              .promise()
              .then((data) => {
                this.brandSelected = data.data.find(
                  (element) =>
                    element.name.toString().trim().toUpperCase() ==
                    message.saleClientSelected['Marca']
                      .toString()
                      .trim()
                      .toUpperCase()
                );

                if (this.brandSelected) {
                  this.onSelectBrand(
                    this.brandSelected,
                    true,
                    message.saleClientSelected['Tipo']
                  );
                }
              });
          }
        });
    } else {
      this.plan_id = null;
      this.assistancecase.assistance_plan_id = null;
    }
  }

  onChangeApplicantName(event) {
    this.assistancecase.applicant_name = event ? event : null;
  }

  onSelectSale(sale) {
    this.assistancecase.assistance_sale_id = null;
    this.selectedSale = null;
    if (sale) {
      this.assistancecase.assistance_sale_id = sale.id;
      this.selectedSale = sale;
      this.sale_canceled =
        this.selectedSale.status == 3 || this.selectedSale.status == 2;
    }
  }

  onEndCount($event: boolean) { }

  onSelectLocation(location) {
    //console.log("ESTOY RECIBIENDO LA UBICACION DESDE EL LINK Y LOS DATOS SON ",location)
    if (location["location_key"]) {

      //----VALIDAR ESTO, ESTO ES EN CASO SE ENVIEN VARIOS LINKS AL CLIENTE Y SE QUIERE QUE FUNCIONE CUALQUIERA, SINO SOLO FUNCIONARIA EL ULTIMO ENVIADO
      if (location["location_key"] != "" && location["location_key"] != this.location_key) {
        this.location_key = location["location_key"] //la location_key que venga en el link es la que voy a enviar
      }

    }
    this.loaderLocation = false;
    this.editLocation.latitude = location.latitude;
    this.editLocation.longitude = location.longitude;

    const coordinates = {
      latitude: location.latitude,
      longitude: location.longitude,
    };

    this.api.assistancecases
      .get_geolocation_by_coordinates(coordinates)
      .post()
      .promise()
      .then((resp) => {
        setTimeout(() => {
          if (resp.result) {
            this.google_address_origen = resp.complete_address;
            this.assistancecase.area = this.assistancecase.area
              ? this.assistancecase.area
              : resp.mayoralty;
            this.assistancecase.suburb = this.assistancecase.suburb
              ? this.assistancecase.suburb
              : resp.neighborhood;
            this.assistancecase.street = this.assistancecase.street
              ? this.assistancecase.street
              : resp.street_number;
            this.assistancecase.postal_code = resp.postal_code
              ? resp.postal_code
              : '00000';
            this.assistancecase.reference = this.assistancecase.reference
              ? this.assistancecase.reference
              : resp.reference;

            if (
              this.caseForm &&
              this.caseForm.form &&
              this.caseForm.form.controls
            ) {
              this.caseForm.form.controls.area?.patchValue(
                this.assistancecase.area
              );
              this.caseForm.form.controls.suburb.patchValue(
                this.assistancecase.suburb
              );
              this.caseForm.form.controls.street.patchValue(
                this.assistancecase.street
              );
              this.caseForm.form.controls.postal_code.patchValue(
                this.assistancecase.postal_code
              );
              this.caseForm.form.controls.reference.patchValue(
                this.assistancecase.reference
              );
            }
          }
        }, 1);
      })
      .catch((e) => {
        this.createCurrentAddress();
      });
  }

  onCancel() {
    this.ref.showDialog = false;
  }

  onSelectMember(member) {
    this.isChubbSaleSelected = true;

    if (this.member?.name) {
      this.DISABLE_DATA_CLIENT = false;
    } else {
      this.DISABLE_DATA_CLIENT = true;
    }

    this.initfield();
    if (member.suggestionEnd) {
      this.createnewmember = new Member();
      if (this.editLocation.latitude) {
        this.createnewmember.longitude = this.editLocation.longitude;
        let latitude = this.createnewmember.latitude;
        this.createnewmember.latitude = latitude;
      } else {
        for (let i = 0; i < this.states.length; i++) {
          if (this.states[i].longitude) {
            this.createnewmember.longitude = this.states[i].longitude;
            this.createnewmember.latitude = this.states[i].latitude;
            break;
          }
        }
      }
      this.createnewmember.country = this.assistancecase.country_id;
      this.memberCreate.emit(this.createnewmember);
    } else {
      this.assistancecase.member_id = member.id;

      this.api.assistances
        .getMemberSaleProducts(member.id)
        .promise()
        .then((resp) => {
          this.shortProducts = resp;
          this.assistanceProducts = _.uniqBy(this.shortProducts, 'id');
          if (!this.assistanceProducts.length) {
            this.haveNoSale = true;
            this.getAssistanceProductsByCountry(this.assistancecase.country_id);
          } else {
            this.haveNoSale = false;
            if (this.assistanceProducts.length === 1) {
              this.assistancecase.assistance_id = this.assistanceProducts[0].id;
              this.onSelectProduct(this.assistancecase.assistance_id);
            }
          }
        });

      this.assistancecase.contact_name = member.name;
      this.assistancecase.member_status = 1;
      if (!this.assistancecase.phone) {
        this.assistancecase.phone = member.mobile;
      }
      if (!this.assistancecase.phone2) {
        this.assistancecase.phone2 = member.phone2;
      }

      if (!this.assistancecase.email) {
        this.assistancecase.email = member.email;
      }

      this.api.assistanceCasesById
        .getLastAddress(member.id)
        .promise()
        .then((rsp) => (this.addressSuggest = rsp));
      this.selectProductFocused.emit(true);
    }

    this.getClientComments(member);
    this.member = member;
    this.complete_address2 = this.member.address;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        step: '2',
      },
      queryParamsHandling: 'merge',
    });
  }

  getClientComments(member) { }
  onSelectMemberChubb(member) {
    this.initfield();

    //---nuevos campos para el assistance_case
    let coverge_id_temp = 0;
    //let AsistenciaEspecialId = null;
    let IdentificadorDeAsistencia = null;
    let TextoLibreAsistencia = null;
    let AplicaEncuesta = true;
    let AplicaAlertas = false;
    let CorreoDeAlertas = null;

    //-------VALIDAMOS SI EL ELEMENTO OBTENIDO DE CHUBB TIENE CONDICIONES ESPECIALES y dependiendo el resultado seteamos un CoverageId

    if (
      Array.isArray(member.CondicionesEspeciales) &&
      member.CondicionesEspeciales.length > 0
    ) {
      coverge_id_temp =
        member.CondicionesEspeciales[0].IdentificadorDeAsistencia;

      IdentificadorDeAsistencia =
        member.CondicionesEspeciales[0].IdentificadorDeAsistencia;
      TextoLibreAsistencia =
        member.CondicionesEspeciales[0].TextoLibreAsistencia;

      AplicaEncuesta = Boolean(member.CondicionesEspeciales[0].AplicaEncuesta);

      AplicaAlertas = Boolean(member.CondicionesEspeciales[0].AplicaAlertas);

      CorreoDeAlertas = member.CondicionesEspeciales[0].CorreoDeAlertas;
    } else {
      coverge_id_temp = member.CoberturaId;
    }

    //---tengo que setear los nuevos campos al assistance case
    this.assistancecase.grouping_id = member['AgrupacionId'];
    this.assistancecase.grouping_chubb = member['Agrupacion'];
    this.assistancecase.attendance_identifier = IdentificadorDeAsistencia;
    this.assistancecase.free_text_attendance = TextoLibreAsistencia;
    this.assistancecase.apply_survey = AplicaEncuesta;
    this.assistancecase.apply_alerts = AplicaAlertas;
    this.assistancecase.alert_mail = CorreoDeAlertas;
    //---agrego el nuevo campo de NumeroInciso
    this.assistancecase.item_number = member['NumeroInciso'];

    //

    this.saleClientSelected = member;

    let request = {
      policy: member.Poliza,
      coverageId: coverge_id_temp,
      effectiveDate: member.InicioVigencia,
      expirationDate: member.FinVigencia,
      firstName: member.PrimerNombre,
      middleName: member.SegundoNombre,
      lastName: member.ApellidoPaterno,
      lastName2: member.ApellidoMaterno,
      numeroSerie: member.NumeroSerie,
      itemNumber: member.NumeroInciso,
    };

    let filter = {
      typeSearch: this.typeSearch,
    };

    this.api.assistances
      .getMemberProductByPlanPolicy(request)
      .params(filter)
      .promise()
      .then((resp) => {
        member = resp['member'];
        this.member = member;
        this.member_name = member.name;
        this.assistancecase.member = member;
        this.assistancecase.member_id = member.id;
        this.shortProducts = resp['data'];
        this.assistancecase.contact_name = member.name;
        this.assistancecase.member_status = 1;
        if (!this.assistancecase.phone) {
          this.assistancecase.phone = member.mobile;
        }
        if (!this.assistancecase.phone2) {
          this.assistancecase.phone2 = member.phone2;
        }

        this.api.assistanceCasesById
          .getLastAddress(member.id)
          .promise()
          .then((rsp) => (this.addressSuggest = rsp));
        this.selectProductFocused.emit(true);
        this.assistanceProducts = _.uniqBy(this.shortProducts, 'id');
        if (!this.assistanceProducts.length) {
          this.haveNoSale = true;
          this.getAssistanceProductsByCountry(this.assistancecase.country_id);
        } else {
          this.haveNoSale = false;
          if (this.assistanceProducts.length === 1) {
            this.assistancecase.assistance_id = this.assistanceProducts[0].id;
            this.onSelectProduct(this.assistancecase.assistance_id);
          }
        }
      });
  }

  getAssistanceProductsByCountry(country_id: number) {
    this.api.assistances
      .byCountryId(country_id)
      .promise()
      .then((resp) => {
        this.shortProducts = resp;
        this.assistanceProducts = _.uniqBy(this.shortProducts, 'id');
      });
  }

  onClearSelectMember() {
    this.assistancecase.member_id = null;
    this.addressSuggest = [];
    this.initfield();
  }

  onSelectAddress(address) {
    this.assistancecase.address = address;
  }

  onClearAddress() {
    this.assistancecase.address = '';
  }

  onQueryAddress(query) {
    this.assistancecase.address = query;
  }

  saveAsistanceCase(ticketService?: AssistanceTicket, member = null) {

    this.assistancecase.location_key = this.location_key;

    if (
      ticketService.service_id == 19 ||
      ticketService.service_id == 133 ||
      ticketService.service_id == 155 ||
      ticketService.service_id == 156
    ) {
      //
      //this.send_notificationcab();
    }

    if (ticketService) {
      this.assistancecase.ticket = _.cloneDeep(ticketService);
    }

    if (
      (!this.assistancecase.member_id && !this.assistancecase.member) ||
      !this.assistancecase.address
    ) {
      if (!this.assistancecase.member_id && !this.assistancecase.member) {
        this.fieldsRequired['member'] = true;
      }
      if (!this.assistancecase.address) {
        this.fieldsRequired['address'] = true;
      }
    } else {
      this.isDisabled = true;
      if (this.haveNoSale) this.assistancecase.member_status = 2;
      this.assistancecase.latitude = this.editLocation.latitude;
      this.assistancecase.longitude = this.editLocation.longitude;

      delete this.assistancecase.date_end;
      delete this.assistancecase.date_start;

      let parameter = {
        typeSearch: this.typeSearch,
        utcoffset: this.utcoffset,
        coverletter_id: null,
      };

      if (
        this.assitanceCoverLetter &&
        this.typeSearch == this.TYPE_SEARCH.COVER_LETTER
      ) {
        //cover letter

        parameter = {
          typeSearch: this.typeSearch,
          utcoffset: this.utcoffset,
          coverletter_id: this.assitanceCoverLetter.id,
        };
      }

      if (this.assistancecase.id) {
        this.api.assistancecases
          .update(this.assistancecase, this.assistancecase.id)
          .promise()
          .then((assistancecase) => {
            this.isDisabled = false;
            assistancecase.is_new = false;
            this.create.emit(assistancecase);
          });
      } else {
        this.loaderService.display(true);

        // Fix agregado debido a que a veces se bloquea
        // el window.open debido a que el navegador lo reconoce
        // como una ventana emergente después de haber recibido la solicitud de Ajax
        let myWindow: any;
        if (!this.redirect_to_v2) {
          myWindow = window.open('');
          myWindow.document.write("<div id='temp'>Loading...<div>");
        }

        if (this.assistancecase.member_id) {
          // select client
          this.api.assistancecases
            .create(this.assistancecase)
            .params(parameter)
            .promise()
            .then((assistancecase) => {
              this.isDisabled = false;
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                  step: null,
                },
                queryParamsHandling: 'merge',
              });
              this.assistancecase.member = member;
              assistancecase.is_new = true;
              this.create.emit(assistancecase);
              this.loaderService.display(false);

              if (this.redirect_to_v2) {
                this.router.navigate([`/admin/assistance/cases/my-cases/${assistancecase.id}`]);

              } else {
                try {
                  myWindow.location.href =
                    '/admin/assistance-v1/cases/' + assistancecase.id + '/tickets/1';
                } catch (e) {
                  myWindow.close();

                  setTimeout(() => {
                    window.open(
                      `/admin/assistance-v1/cases/${assistancecase.id}/tickets/1`,
                      '_blank'
                    );
                  }, 250);
                }

              }

            })
            .catch((e) => {
              if (myWindow) {
                myWindow.close();
              }

              this.isDisabled = false;
              this.loaderService.display(false);
              this.assistancecase.member = member;
              this.translate
                .get('An error occurred while creating the management')
                .subscribe((res: string) => {
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: `${res}`,
                  });
                });
            });
        } else {
          // new client created

          this.api.assistancecases
            .create(this.assistancecase)
            .params(parameter)
            .promise()
            .then((assistancecase) => {
              this.isDisabled = false;
              assistancecase.is_new = true;
              this.create.emit(assistancecase);
              this.loaderService.display(false);

              if (this.redirect_to_v2) {
                this.router.navigate([`/admin/assistance/cases/my-cases/${assistancecase.id}`]);

              } else {

                try {
                  myWindow.location.href = `/admin/assistance-v1/cases/${assistancecase.id}/tickets/1`;
                } catch (e) {
                  myWindow.close();

                  setTimeout(() => {
                    window.open(
                      `/admin/assistance-v1/cases/${assistancecase.id}/tickets/1`,
                      '_blank'
                    );
                  }, 250);
                }

              }

            })
            .catch((e) => {
              if (myWindow) {
                myWindow.close();
              }

              this.isDisabled = false;
              this.loaderService.display(false);
              const errmsg = JSON.parse(e['_body']);
              this.translate.get(errmsg.error).subscribe((res: string) => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: `${res}`,
                });
              });
            });
        }
      }
      this.clearCount.emit(true);
    }
  }

  stopCount() {
    this.clearCount.emit(true);
  }

  setIsMemberDisabled() {
    if (this.assistancecase.country_id != null) {
      this.isMemberDisabled = false;
    } else {
      this.isMemberDisabled = true;
    }
  }

  emitStateLocation() {
    if (
      this.state &&
      this.state.latitude != null &&
      this.state.longitude != null
    ) {
      const statelocation = {
        latitude: this.state.latitude,
        longitude: this.state.longitude,
      };
      this.stateLocation.emit(statelocation);
    }
  }

  onNotificationReceived(payload) {
    this.editLocation.latitude = payload.latitude;
    this.editLocation.longitude = payload.longitude;
  }

  prevPage() {
    this.page -= 1;
    this.searchMemberSales('');
  }

  nextPage($event) {
    this.page = $event.page + 1;
    this.searchMemberSales('');
  }

  searchMemberSales(event) {
    if (this.company_id == 'apolo') {
      if (this.country_id != null) {
        if (this.searching) {
          return;
        }

        if (this.assistancecase.country_id == null) {
          this.onSelectCountry(this.country_id);
        }
        if (this.typeSearch == this.TYPE_SEARCH.BY_CONECTION) {
          this.selectGestionByConnection();
        } else if (this.typeSearch == this.TYPE_SEARCH.MANUAL_CASE) {
          this.selectGestionManual();
        } else if (this.typeSearch == 9) {
          this.loaderService.display(true);
          this.searching = true;
          this.api.members
            .getSales({
              country: this.country_id,
              sale_status: this.search_sale_status,
              name_or_mobile: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        } else if (this.typeSearch == 10) {
          this.loaderService.display(true);
          this.searching = true;
          this.api.members
            .getSalesWithAssistanceCode({
              country: this.country_id,
              sale_status: this.search_sale_status,
              assistance_code: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        } else if (this.typeSearch == 11) {
          this.loaderService.display(true);
          this.searching = true;
          this.api.members
            .getSalesWithNationalID({
              country: this.country_id,
              sale_status: this.search_sale_status,
              name_or_mobile: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        } else if (this.typeSearch == 12) {
          this.loaderService.display(true);
          this.searching = true;
          this.api.members
            .getSalesWithPhone({
              country: this.country_id,
              sale_status: this.search_sale_status,
              name_or_mobile: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        } else if (this.typeSearch == 99) {
          this.loaderService.display(true);
          this.api.members
            .getSalesWithCarPlate({
              country: this.country_id,
              sale_status: this.search_sale_status,
              car_plate: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        } else if (this.typeSearch == 50) {
          this.loaderService.display(true);
          this.api.members
            .getSalesWithCarEngineNumber({
              country: this.country_id,
              sale_status: this.search_sale_status,
              engine_number: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        } else if (this.typeSearch == 55) {
          this.loaderService.display(true);
          this.api.members
            .getSalesWithCarSerialNumber({
              country: this.country_id,
              sale_status: this.search_sale_status,
              serial_number: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        } else if (this.typeSearch == this.TYPE_SEARCH.EMAIL) {
          this.loaderService.display(true);
          this.searching = true;
          this.api.members
            .getSalesWithEmail({
              country: this.country_id,
              sale_status: this.search_sale_status,
              email: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        }


        else if (this.typeSearch == this.TYPE_SEARCH.TAX_NUMBER) {
          this.loaderService.display(true);
          this.searching = true;
          this.api.members
            .getSalesWithTaxNumber({
              country: this.country_id,
              sale_status: this.search_sale_status,
              tax_number: this.member_name,
            })
            .page(this.page)
            .per_page(20)
            .promise()
            .then((data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            })
            .catch((err) => {
              this.loaderService.display(false);
              this.searching = false;
            });
          this.resultDialog = true;
        }


      } else {
        this.showCountryError = true;
        this.sales = null;
      }


    } else if (this.company_id == 'mok') {
      let payload = {
        name_or_mobile: this.member_name,
        mok_queryparam: '',
        endpoint: this.mok_url
      }
      if (this.typeSearch == 9) {
        payload['mok_queryparam'] = 'document_identifier'
      } else if (this.typeSearch == 11) {
        payload['mok_queryparam'] = 'national_id'
      } else if (this.typeSearch == this.TYPE_SEARCH.EMAIL) {
        payload['mok_queryparam'] = 'email'
      }

      this.loaderService.display(true);
      this.searching = true;
      this.api.mok_integration.get_assistance_case_by_contract(payload)
        .page(this.page)
        .per_page(20)
        .promise()
        .then((data) => {
          console.log(data)
          this.assistancesales = data[0].contracts;
          this.totalCount = data[1];
          this.loaderService.display(false);
          this.searching = false;
        })
        .catch((err) => {
          this.loaderService.display(false);
          this.searching = false;
        });
      this.resultDialog = true;
    }
  }

  searchMember(event) {
    if (this.country_id != null) {
      if (this.assistancecase.country_id == null) {
        this.onSelectCountry(this.country_id);
      }

      if (this.searching) {
        return;
      }

      this.searching = true;
      this.members = null;

      this.filter = null;
      this.page = 1;
      this.total = 0;

      let request = {};

      let parameter = {
        typeSearch: this.typeSearch,
      };

      if (this.typeSearch == 9) {
        let filter;

        filter = {
          country: this.country_id,
          name_or_mobile: { $like: '%' + this.member_name + '%' },
        };

        this.filter = filter;

        this.getMembers();
        this.resultDialog = true;
      }
    } else {
      this.showCountryError = true;
      this.sales = null;
    }
  }

  getMembers() {
    this.loaderService.display(true);
    this.api.members
      .get()
      .filter(this.filter)
      .page(this.page)
      .per_page(20)
      .promise()
      .then((rsp) => {
        this.members = rsp.data;
        this.total = rsp.total;
        this.searching = false;
        this.loaderService.display(false);
      })
      .catch((e) => {
        this.searching = false;
      });
  }

  onDropdownClick(sale?) {

    if (sale && sale.member) {
      this.member = sale.member;
      this.complete_address2 = this.member.address;
      if (
        sale.member &&
        (this.typeSearch == 9 ||
          this.typeSearch == 10 ||
          this.typeSearch == 11 ||
          this.typeSearch == 12 ||
          this.typeSearch == 99 ||
          this.typeSearch == 50 ||
          this.typeSearch == 55 ||
          this.typeSearch == this.TYPE_SEARCH.EMAIL ||
          this.typeSearch == this.TYPE_SEARCH.TAX_NUMBER
        )
      ) {
        this.member = sale.member;
        this.member_name = this.member.name;
        this.assistancecase.member_id = this.member.id;
        this.members = null;
        this.sale = sale;
        this.onSelectSale(sale);
        this.getFastService(sale.plan.id);
        this.api.assistancecategoryByPlanId
          .get(sale.plan.id)
          .promise()
          .then((response) => {
            this.assistancecategories = response.data || [];
            if (sale.category == 'BUCA INSURANCE') {
              this.assistancecategories = this.assistancecategories.filter(
                (element) => !(element.buca_type === 0)
              );
            }
          });

        if (this.member.name) {
          this.DISABLE_DATA_CLIENT = false;
        } else {
          this.DISABLE_DATA_CLIENT = true;
        }

        setTimeout(() => {
          if (
            this.caseForm &&
            this.caseForm.form &&
            this.caseForm.form.controls
          ) {
            if (sale.member.membercountry.name == 'México') {
              this.assistancecase.country_phone_code = 52;
              this.caseForm.form.controls.country_phone_code.patchValue(52);
            } else if (sale.member.membercountry.name == 'Guatemala') {
              this.assistancecase.country_phone_code = 502;
              this.caseForm.form.controls.country_phone_code.patchValue(502);
            } else if (sale.member.membercountry.name == 'Costa Rica') {
              this.assistancecase.country_phone_code = 506;
              this.caseForm.form.controls.country_phone_code.patchValue(506);
            } else if (sale.member.membercountry.name == 'Honduras') {
              this.assistancecase.country_phone_code = 504;
              this.caseForm.form.controls.country_phone_code.patchValue(504);
            } else if (sale.member.membercountry.name == 'El Salvador') {
              this.assistancecase.country_phone_code = 503;
              this.caseForm.form.controls.country_phone_code.patchValue(503);
            } else if (sale.member.membercountry.name == 'Nicaragua') {
              this.assistancecase.country_phone_code = 505;
              this.caseForm.form.controls.country_phone_code.patchValue(505);
            } else if (sale.member.membercountry.name == 'Panama') {
              this.assistancecase.country_phone_code = 507;
              this.caseForm.form.controls.country_phone_code.patchValue(507);
            } else if (
              sale.member.membercountry.name == 'República Dominicana'
            ) {
              this.assistancecase.country_phone_code = 1809;
              this.caseForm.form.controls.country_phone_code.patchValue(1809);
            } else if (sale.member.membercountry.name == 'Trinidad y Tobago') {
              this.assistancecase.country_phone_code = 1868;
              this.caseForm.form.controls.country_phone_code.patchValue(1868);
            } else if (sale.member.membercountry.name == 'Jamaica') {
              this.assistancecase.country_phone_code = 1876;
              this.caseForm.form.controls.country_phone_code.patchValue(1876);
            } else if (sale.member.membercountry.name == 'Paraguay') {
              this.assistancecase.country_phone_code = 595;
              this.caseForm.form.controls.country_phone_code.patchValue(595);
            }
          }
        }, 250);

        this.assistancecase.contact_name = sale.member.name;
        this.assistancecase.member_status = 1;
        if (sale.member.mobile) {
          this.assistancecase.phone = sale.member.mobile;
        }
        if (sale.member.phone2) {
          this.assistancecase.phone2 = sale.member.phone2;
        }
        if (sale.member.email) {
          this.assistancecase.email = sale.member.email;
        }
        this.assistancecase.assistance_plan_id = sale.plan.id;
        this.assistancecase.assistance_sale_id = sale.id;
        this.assistancecase.assistance_id = sale.plan.product.id;
        this.assistancecase.member = sale.member;

        this.plan_id = sale.plan.id;

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            step: '2',
          },
          queryParamsHandling: 'merge',
        });
        this.isChubbSaleSelected = true;
        this.resultDialog = false;
      }
      if (this.typeSearch == this.TYPE_SEARCH.BY_CONECTION) {
        this.getFastService(this.assitanceByConection.plan_id);
        this.api.assistancecategoryByPlanId
          .get(this.assitanceByConection.plan_id)
          .promise()
          .then((response) => {
            this.assistancecategories = response.data || [];
          });
        setTimeout(() => {
          if (
            this.caseForm &&
            this.caseForm.form &&
            this.caseForm.form.controls
          ) {
            if (this.country.name == 'México') {
              this.assistancecase.country_phone_code = 52;
              this.caseForm.form.controls.country_phone_code.patchValue(52);
            } else if (this.country.name == 'Guatemala') {
              this.assistancecase.country_phone_code = 502;
              this.caseForm.form.controls.country_phone_code.patchValue(502);
            } else if (this.country.name == 'Costa Rica') {
              this.assistancecase.country_phone_code = 506;
              this.caseForm.form.controls.country_phone_code.patchValue(506);
            } else if (this.country.name == 'Honduras') {
              this.assistancecase.country_phone_code = 504;
              this.caseForm.form.controls.country_phone_code.patchValue(504);
            } else if (this.country.name == 'El Salvador') {
              this.assistancecase.country_phone_code = 503;
              this.caseForm.form.controls.country_phone_code.patchValue(503);
            } else if (this.country.name == 'Nicaragua') {
              this.assistancecase.country_phone_code = 505;
              this.caseForm.form.controls.country_phone_code.patchValue(505);
            } else if (this.country.name == 'Panama') {
              this.assistancecase.country_phone_code = 507;
              this.caseForm.form.controls.country_phone_code.patchValue(507);
            } else if (this.country.name == 'República Dominicana') {
              this.assistancecase.country_phone_code = 1809;
              this.caseForm.form.controls.country_phone_code.patchValue(1809);
            } else if (this.country.name == 'Trinidad y Tobago') {
              this.assistancecase.country_phone_code = 1868;
              this.caseForm.form.controls.country_phone_code.patchValue(1868);
            } else if (this.country.name == 'Jamaica') {
              this.assistancecase.country_phone_code = 1876;
              this.caseForm.form.controls.country_phone_code.patchValue(1876);
            } else if (this.country.name == 'Paraguay') {
              this.assistancecase.country_phone_code = 595;
              this.caseForm.form.controls.country_phone_code.patchValue(595);
            }
          }
        }, 250);

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            step: '2',
          },
          queryParamsHandling: 'merge',
        });
        this.isChubbSaleSelected = true;
        this.isConectionSelected = false;
      }
    } else {
      if (
        this.typeSearch == this.TYPE_SEARCH.MANUAL_CASE ||
        this.typeSearch == this.TYPE_SEARCH.BY_CONECTION
      ) {
        /*CREAR MEMBER*/

        this.createManualMember = new Member();
        this.createManualMember.first_name = this.assistancecase.contact_name;
        this.createManualMember.name = this.assistancecase.contact_name;
        this.createManualMember.national_id = this.member_national_id;
        //country
        this.createManualMember.country = this.country_id;
        this.createManualMember.is_new = true;
        this.onMemberSave(this.createManualMember);
        this.getFastService(this.plan_id);
        this.api.assistancecategoryByPlanId
          .get(this.plan_id)
          .promise()
          .then((response) => {
            this.assistancecategories = response.data || [];
          });
        setTimeout(() => {
          if (
            this.caseForm &&
            this.caseForm.form &&
            this.caseForm.form.controls
          ) {
            if (this.country.name == 'México') {
              this.assistancecase.country_phone_code = 52;
              this.caseForm.form.controls.country_phone_code.patchValue(52);
            } else if (this.country.name == 'Guatemala') {
              this.assistancecase.country_phone_code = 502;
              this.caseForm.form.controls.country_phone_code.patchValue(502);
            } else if (this.country.name == 'Costa Rica') {
              this.assistancecase.country_phone_code = 506;
              this.caseForm.form.controls.country_phone_code.patchValue(506);
            } else if (this.country.name == 'Honduras') {
              this.assistancecase.country_phone_code = 504;
              this.caseForm.form.controls.country_phone_code.patchValue(504);
            } else if (this.country.name == 'El Salvador') {
              this.assistancecase.country_phone_code = 503;
              this.caseForm.form.controls.country_phone_code.patchValue(503);
            } else if (this.country.name == 'Nicaragua') {
              this.assistancecase.country_phone_code = 505;
              this.caseForm.form.controls.country_phone_code.patchValue(505);
            } else if (this.country.name == 'Panama') {
              this.assistancecase.country_phone_code = 507;
              this.caseForm.form.controls.country_phone_code.patchValue(507);
            } else if (this.country.name == 'República Dominicana') {
              this.assistancecase.country_phone_code = 1809;
              this.caseForm.form.controls.country_phone_code.patchValue(1809);
            } else if (this.country.name == 'Trinidad y Tobago') {
              this.assistancecase.country_phone_code = 1868;
              this.caseForm.form.controls.country_phone_code.patchValue(1868);
            } else if (this.country.name == 'Jamaica') {
              this.assistancecase.country_phone_code = 1876;
              this.caseForm.form.controls.country_phone_code.patchValue(1876);
            } else if (this.country.name == 'Paraguay') {
              this.assistancecase.country_phone_code = 595;
              this.caseForm.form.controls.country_phone_code.patchValue(595);
            }
          }
        }, 250);
        this.assistancecase.assistance_plan_id = this.plan_id;

        this.api.assistancePlansAndProducts
          .get(this.plan_id)
          .promise()
          .then(
            (assistance_plan) =>
            (this.assistancecase.assistance_id =
              assistance_plan[0].assistance_id)
          );

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            step: '2',
          },
          queryParamsHandling: 'merge',
        });
        this.isChubbSaleSelected = true;
        this.isConectionSelected = false;
      } else if (this.is_mok_search) {
        this.loaderService.display(true)
        this.api.mok_integration.create_sale_from_contract(sale).promise().then(
          response => {
            this.loaderService.display(false)
            console.log(response)

            this.getFastService(response.plan_id);
            this.country = _.find(this.countries, function (c) {
              return c.id === response.country_id;
            });
            console.log(this.country)
            this.assistancecase.country_id = response.country_id;
            this.plan_id = response.plan_id
            this.selectedSale = response.sale
            this.member = response.member
            this.api.assistancecategoryByPlanId
              .get(response.plan_id)
              .promise()
              .then((response) => {
                this.assistancecategories = response.data || [];
              });
            setTimeout(() => {
              if (
                this.caseForm &&
                this.caseForm.form &&
                this.caseForm.form.controls
              ) {
                if (this.country.name == 'México') {
                  this.assistancecase.country_phone_code = 52;
                  this.caseForm.form.controls.country_phone_code.patchValue(52);
                } else if (this.country.name == 'Guatemala') {
                  this.assistancecase.country_phone_code = 502;
                  this.caseForm.form.controls.country_phone_code.patchValue(502);
                } else if (this.country.name == 'Costa Rica') {
                  this.assistancecase.country_phone_code = 506;
                  this.caseForm.form.controls.country_phone_code.patchValue(506);
                } else if (this.country.name == 'Honduras') {
                  this.assistancecase.country_phone_code = 504;
                  this.caseForm.form.controls.country_phone_code.patchValue(504);
                } else if (this.country.name == 'El Salvador') {
                  this.assistancecase.country_phone_code = 503;
                  this.caseForm.form.controls.country_phone_code.patchValue(503);
                } else if (this.country.name == 'Nicaragua') {
                  this.assistancecase.country_phone_code = 505;
                  this.caseForm.form.controls.country_phone_code.patchValue(505);
                } else if (this.country.name == 'Panama') {
                  this.assistancecase.country_phone_code = 507;
                  this.caseForm.form.controls.country_phone_code.patchValue(507);
                } else if (this.country.name == 'República Dominicana') {
                  this.assistancecase.country_phone_code = 1809;
                  this.caseForm.form.controls.country_phone_code.patchValue(1809);
                } else if (this.country.name == 'Trinidad y Tobago') {
                  this.assistancecase.country_phone_code = 1868;
                  this.caseForm.form.controls.country_phone_code.patchValue(1868);
                } else if (this.country.name == 'Jamaica') {
                  this.assistancecase.country_phone_code = 1876;
                  this.caseForm.form.controls.country_phone_code.patchValue(1876);
                } else if (this.country.name == 'Paraguay') {
                  this.assistancecase.country_phone_code = 595;
                  this.caseForm.form.controls.country_phone_code.patchValue(595);
                }
              }
            }, 250);
            this.assistancecase.assistance_plan_id = response.plan_id;
            this.assistancecase.assistance_sale_id = response.sale_id;
            this.assistancecase.member_id = response.member_id
            this.sale = response.sale
            this.assistancecase.contact_name = this.sale.member.name
            this.assistancecase.origin_country_id = response.country_id;
            this.assistancecase.destination_country_id = response.country_id;
            this.assistancecase.phone = response.member.mobile;
            this.assistancecase.email = response.member.email;
            this.onSelectCountryOrigin(response.country_id)
            this.onSelectCountryDestination(response.country_id)
            console.log(this.sale)
            this.api.assistancePlansAndProducts
              .get(response.plan_id)
              .promise()
              .then(
                (assistance_plan) =>
                (this.assistancecase.assistance_id =
                  assistance_plan[0].assistance_id)
              );

            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                step: '2',
              },
              queryParamsHandling: 'merge',
            });
          }
        )
      } else {
        this.onSelectMember({ name: '', suggestionEnd: true } as any);
      }
    }
  }

  onMemberSave(member: Member) {
    this.loaderService.display(true);
    if (member.is_new) {
      this.api.members
        .create(member)
        .promise()
        .then((newMember) => {
          this.totalCount++;
          this.loaderService.display(false);
          this.id_manual = newMember.id;
          this.assistancecase.member_id = this.id_manual;
        })
        .catch((e) => {
          this.loaderService.display(false);
        });
    } else {
      this.api.members
        .update(member, member.id)
        .promise()
        .then(() => {
          this.loaderService.display(false);
        })
        .catch((e) => {
          this.loaderService.display(false);
        });
    }
  }
  searchCoverLetter() {
    let payload = {
      searchName: this.companyName,
    };

    this.api.assistanceCoverletter
      .search(payload)
      .promise()
      .then((resp) => {
        this.assistanceCoverLetters = resp[0];
        this.searching = false;
        this.loaderService.display(false);
      })
      .catch((e) => {
        this.searching = false;

        this.loaderService.display(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          life: 10000,
          detail: `${e.error.message || e.error}`,
        });
      });
  }

  selectChubbSale(chubbSale) {
    this.sale = chubbSale;
    this.isChubbSaleSelected = true;

    if (!this.sale.PrimerNombre) {
      this.DISABLE_DATA_CLIENT = false;
    } else {
      this.DISABLE_DATA_CLIENT = true;
    }

    setTimeout(() => {
      if (this.caseForm && this.caseForm.form && this.caseForm.form.controls) {
        this.assistancecase.country_phone_code = 52;
        this.caseForm.form.controls.country_phone_code.patchValue(52);
      }
    }, 250);

    this.onDropdownClick(chubbSale);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        step: '2',
      },
      queryParamsHandling: 'merge',
    });
  }

  getSelectService() {
    return this.serviceSelected;
  }

  async getQuestions(serviceId) {
    this.api.assistanceSaleQuestions
      .get(serviceId)
      .promise()
      .then((response) => {
        this.loaderService.display(false);
        this.questions = response;
        if (this.questions) {
          this.questions.forEach((question) => {
            if (question.question_type == 'textbox') {
              question['answer_text'] = '';
            } else if (question.question_type == 'radio') {
              question['option_selected_id'] = 0;
            }
          });
        }
      })
      .catch((e) => {
        this.loaderService.display(false);
      });
  }

  async selectService(category, service) {
    if (category == 0 && service == 0) {
      return;
    }
    this.serviceSelected = service;
    if (category != -1 && service != -1) {
      this.selectCategory_id = category;
      await this.onSelectCategory(category + '');
      this.editticket.service_id = service;
      this.onSelectService(service + '');
    } else {
      this.serviceSelected = -1;
    }
  }

  selectCoverLetter(coverLetter: AssistanceCoverLetter) {
    let param = {
      utcoffset: this.utcoffset,
    };

    this.api.assistanceCoverletter
      .validateDates(coverLetter.id)
      .params(param)
      .promise()
      .then((resp) => {
        this.assitanceCoverLetter = coverLetter;
        this.sale = {
          ApellidoMaterno: null,
          ApellidoPaterno: null,
          Cobertura: 'ASISTENCIA EN VIAJE IKE *',
          CoberturaId: null,
          DescripcionVehiculo: null,
          Estatus: null,
          FinVigencia: null,
          InicioVigencia: null,
          Marca: null,
          Modelo: null,
          NumeroInciso: null,
          NumeroSerie: null,
          Placas: null,
          Poliza: null,
          PrimerNombre: null,
          SegundoNombre: null,
          Tipo: null,
          razonSocial: null,
        };

        this.sale.CoberturaId = coverLetter.plan_id;

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            step: 'coverletter2',
          },
          queryParamsHandling: 'merge',
        });
      })
      .catch((e) => {
        this.translate.get('Invalid Cover Letter').subscribe((res: string) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: res,
          });
        });
      });
  }

  selectGestionByConnection() {
    const filter_plan = { id: this.PLAN_BY_CONECTION_ID };
    this.plan_id = this.PLAN_BY_CONECTION_ID;
    this.api.assistanceplans
      .get()
      .filter(filter_plan)
      .promise()
      .then((resp) => {
        this.loaderService.display(false);
        this.searching = false;
        this.assitanceByConection = new AssistanceGestionByConection();
        this.assitanceByConection.plan_id = resp.data[0].id;
        this.sale = {
          ApellidoMaterno: null,
          ApellidoPaterno: null,
          Cobertura: 'ASISTENCIA EN VIAJE IKE *',
          CoberturaId: resp.data[0].id,
          DescripcionVehiculo: null,
          Estatus: null,
          FinVigencia: null,
          InicioVigencia: null,
          Marca: null,
          Modelo: null,
          NumeroInciso: null,
          NumeroSerie: null,
          Placas: null,
          Poliza: null,
          PrimerNombre: null,
          SegundoNombre: null,
          Tipo: null,
          razonSocial: null,
        };

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            step: 'conection2',
          },
          queryParamsHandling: 'merge',
        });
      })
      .catch((e) => {
        this.loaderService.display(false);
        this.searching = false;
        this.assitanceByConection = null;
        this.translate
          .get('Error get plan by connection')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res,
            });
          });
      });
  }

  selectGestionManual() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        step: 'conection2',
      },
      queryParamsHandling: 'merge',
    });
  }

  viewCallDialog() {
    this.showPhonesNumberDialog = true;
  }

  onSelectCountryPhoneCode(event) { }

  requestLocation(shippingMethod: number) {
    this.loaderLocation = true;
    //this.location_key= this.generateRandomString(10) //key random de longitud 10

    this.api.assistanceCasesById.getLocationKeyUnique(0).promise()
      .then((response) => {
        // return response.uuid
        this.location_key = response.uuid
        // If this method is sms, send email too
        this.sendRequestLocation(shippingMethod)

      }).catch(error => {
        return ""
      })



  }

  sendRequestLocation(shippingMethod) {

    if (
      this.assistancecase.email &&
      shippingMethod == this.selectLocationComponent.SHIPPING_METHOD.EMAIL
    ) {
      this.selectLocationComponent.sendMessage(
        this.selectLocationComponent.SHIPPING_METHOD.EMAIL, this.location_key, this.assistancecase.assistance_id
      );
    } else {
      this.selectLocationComponent.sendMessage(shippingMethod, this.location_key, this.assistancecase.assistance_id);
    }
  }


  onChangeItemSelected(itemSelected) {
    this.itemSelected = itemSelected;
    let value = itemSelected.id;
    this.program_type = +value || null;
    this.editticket.program_type = +value || null;
    this.onSelectProgramSubType(value);
  }

  onSetServiceProgramed() {
    this.showProgramedService = !this.showProgramedService;
    this.isChubbSaleSelected = !this.isChubbSaleSelected;
    this.editticket.programdate = this.programTimeService;
    this.flagProgramedService = true;
    this.editticket.program_subtype = this.program_subtype;
  }

  onCloseServiceProgramed() {
    this.showProgramedService = !this.showProgramedService;
    this.isChubbSaleSelected = !this.isChubbSaleSelected;
    this.editticket.programdate = null;
    this.flagProgramedService = false;
    this.editticket.program_subtype = null;
    this.editticket.programmed = null;
  }

  getWithOfDivService() {
    if (this.divService != undefined && this.cardService != undefined) {
      let half = this.divService.nativeElement.offsetWidth;
      if (this.widthOfDiveService != half) {
        this.widthOfDiveService = half;
        let result = (half / 2 - 188) / 4;
        let width = result * 2 + 188;
        this.cardService.nativeElement.style.width = Math.floor(width) + 'px';
        return Math.floor(width);
      }
      return half;
    } else {
      return 0;
    }
  }

  displayViewProgramService() {
    if (!this.flagProgramedService) {
      this.showProgramedService = !this.showProgramedService;
      this.isChubbSaleSelected = !this.isChubbSaleSelected;
      this.onSelectProgram(1);
    } else {
      this.flagProgramedService = !this.flagProgramedService;
      this.showConfirmQuitProgram = !this.showConfirmQuitProgram;
      this.onSelectProgram(0);
    }
    this.widthOfDiveService = 0;
  }

  displayButtonByConnection(value?) {
    this.showConfirmByConection = value || !this.showConfirmByConection;
    this.showConfirmByConection == true
      ? this.onSelectConnection(1)
      : this.onSelectConnection(0);
  }

  displayButtonByRecordination(value?) {
    this.showConfirmByRecordination = value || !this.showConfirmByRecordination;
    this.showConfirmByRecordination == true
      ? this.onSelectRecordination(1)
      : this.onSelectRecordination(0);
  }

  onSelectRecordination(value) {
    this.recordination = value;
    this.editticket.recordination = value;
  }

  backSearchCoverLetter() {
    this.isCoverLetterSelected = false;
    this.assitanceCoverLetter = null;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        step: 'coverletter1',
      },
      queryParamsHandling: 'merge',
    });
  }

  backGestionByConection() {
    this.isConectionSelected = false;
    this.assitanceByConection = null;
    this.typeSearch = this.TYPE_SEARCH.POLICY;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        step: '1',
      },
      queryParamsHandling: 'merge',
    });
  }

  changeTypeSearch(value) {
    if (value == 1) {
      this.changeMessageNavBar.emit(
        'Create Assistance Case by Coverage Letter'
      );
    } else if (value == 8) {
      this.changeMessageNavBar.emit('Create Assistance Case by Conection');
    } else {
      this.changeMessageNavBar.emit('Create Assistance Case');
    }
  }

  contatenarPreguntas() {
    let respuestaPregunta2 = '';
    if (this.respuestaDondeEstaVaradoElVehiculo == 'Estacionamiento') {
      respuestaPregunta2 = `${this.preguntaDondeEstaVaradoElVehiculo} ${this.respuestaDondeEstaVaradoElVehiculo}, ${this.preguntaAireLibre} ${this.respuestaAireLibre}, ${this.preguntaNivel} ${this.respuestaNivel}, ${this.preguntaLimitanteIngreso} ${this.respuestaLimitanteIngreso}`;
    } else {
      respuestaPregunta2 = `${this.preguntaDondeEstaVaradoElVehiculo} ${this.respuestaDondeEstaVaradoElVehiculo}`;
    }

    let pregunta11 = `${this.preguntaViajaAcompaniante} ${this.respuestaViajaAcompaniante}`;
    if (this.respuestaViajaAcompaniante == 'Si') {
      pregunta11 = `${this.preguntaViajaAcompaniante} ${this.respuestaViajaAcompaniante},  ${this.pregunta11Sub1Grua.questions}: ${this.pregunta11Sub1Grua.answer}, ${this.pregunta11Sub2Grua.questions}: ${this.pregunta11Sub2Grua.answer}`;
    }

    let preguntatipocarga = '';
    if (this.respuestaTieneAlgunTipoDeCarga == 'Si') {
      preguntatipocarga = `${this.preguntaTipoCarga} ${this.respuestaTipoCarga} \n ${this.preguntaPesoAproximado} ${this.respuestaPesoAproximado} `;
    }

    let question8 = `${this.question8Grua.questions}: ${this.question8Grua.answer}`;

    if (this.question8Grua.answer == 'Si') {
      let answerQuestion8Sub1 = '';

      if (this.question8Sub1Grua.answer) {
        answerQuestion8Sub1 = this.question8Sub1Grua.answer.value;
      }

      question8 = `${this.question8Grua.questions}: ${this.question8Grua.answer}, ${this.question8Sub1Grua.questions}: ${answerQuestion8Sub1}, ${this.question8Sub2grua.questions}: ${this.question8Sub2grua.answer}`;
    }

    let preguntagira = '';
    if (this.respuestaGiraLlantas == 'No') {
      const respuesta1 = document.getElementById(
        'respuestallantadelanteraizquierda'
      ) as HTMLInputElement | null;
      const respuesta2 = document.getElementById(
        'respuestaLlantadelanteraderecha'
      ) as HTMLInputElement | null;
      const respuesta3 = document.getElementById(
        'respuestaLlantatraseraizquierda'
      ) as HTMLInputElement | null;
      const respuesta4 = document.getElementById(
        'respuestaLlantatraseraderecha'
      ) as HTMLInputElement | null;
      preguntagira = '\n' + '¿Cuál es la llanta que no gira?' + '\n';
      if (respuesta1.checked) {
        preguntagira = preguntagira + 'Delantera izquierda' + '\n';
      }
      if (respuesta2.checked) {
        preguntagira = preguntagira + 'Delantera derecha' + '\n';
      }
      if (respuesta3.checked) {
        preguntagira = preguntagira + 'Trasera izquierda' + '\n';
      }
      if (respuesta4.checked) {
        preguntagira = preguntagira + 'Trasera derecha' + '\n';
      }
    }

    this.comment = `${this.preguntaGiranLasLlantas} ${this.respuestaGiraLlantas} ${preguntagira}
${this.preguntaSePuedePonerEnNeutral} ${this.respuestaSePuedePonerEnNeutral}
${this.preguntaTieneAlgunTipoDeCarga} ${this.respuestaTieneAlgunTipoDeCarga}
${preguntatipocarga}
${respuestaPregunta2}
${this.preguntaQueTiempoLlevaVarado} ${this.respuestaQueTiempoLllevaVarado}
${this.preguntaEsAutomaticoOEstandar} ${this.respuestaEsAutomaticoOEstandar}
${question8}
${this.preguntaQuienRecibeYAcompaniaElServicio} ${this.respuestaQuienRecibeYAcompaniaElServicio}
${this.preguntaIdentificacionPiloto} ${this.respuestaIdentificacionPiloto}
${pregunta11}
${this.question12} ${this.answerQuestion12}`;
  }

  contatenarPreguntasCerrajero() {
    this.comment = `${this.pregunta1Cerrajero.questions}: ${this.pregunta1Cerrajero.answer}
${this.pregunta2Cerrajero.questions}: ${this.pregunta2Cerrajero.answer}
${this.pregunta3Cerrajero.questions}: ${this.pregunta3Cerrajero.answer}
${this.pregunta4Cerrajero.questions}: ${this.pregunta4Cerrajero.answer}`;
  }

  concatenarPreguntasNutricional() {
    this.comment = `${this.pregunta1Nutricional.questions}: ${this.pregunta1Nutricional.answer}
${this.pregunta2Nutricional.questions}: ${this.pregunta2Nutricional.answer}
${this.pregunta3Nutricional.questions}: ${this.pregunta3Nutricional.answer}
${this.pregunta4Nutricional.questions}: ${this.pregunta4Nutricional.answer}
${this.pregunta5Nutricional.questions}: ${this.pregunta5Nutricional.answer}
${this.pregunta6Nutricional.questions}: ${this.pregunta6Nutricional.answer}
${this.pregunta7Nutricional.questions}: ${this.pregunta7Nutricional.answer}
${this.pregunta8Nutricional.questions}: ${this.pregunta8Nutricional.answer}`;
  }
  concatenarPreguntasMedicalTransfer() {
    this.comment = `${this.pregunta1MedicalTransfer.questions}: ${this.pregunta1MedicalTransfer.answer}
${this.pregunta2MedicalTransfer.questions}: ${this.pregunta2MedicalTransfer.answer}
${this.pregunta3MedicalTransfer.questions}: ${this.pregunta3MedicalTransfer.answer}
${this.pregunta4MedicalTransfer.questions}: ${this.pregunta4MedicalTransfer.answer}
${this.pregunta5MedicalTransfer.questions}: ${this.pregunta5MedicalTransfer.answer}
${this.pregunta6MedicalTransfer.questions}: ${this.pregunta6MedicalTransfer.answer}
${this.pregunta7MedicalTransfer.questions}: ${this.pregunta7MedicalTransfer.answer}
${this.pregunta8MedicalTransfer.questions}: ${this.pregunta8MedicalTransfer.answer}`;
  }
  concatenarPreguntasHeavyVehicule() {
    if (this.pregunta5HeavyVehicule.answer != 'Otro') {
      this.pregunta6HeavyVehicule.answer = '';
    }

    this.comment = `${this.pregunta1HeavyVehicule.questions}: ${this.pregunta1HeavyVehicule.answer}
${this.pregunta2HeavyVehicule.questions}: ${this.pregunta2HeavyVehicule.answer}
${this.pregunta3HeavyVehicule.questions}: ${this.pregunta3HeavyVehicule.answer}
${this.pregunta4HeavyVehicule.questions}: ${this.pregunta4HeavyVehicule.answer}
${this.pregunta5HeavyVehicule.questions}: ${this.pregunta5HeavyVehicule.answer}
${this.pregunta6HeavyVehicule.questions}: ${this.pregunta6HeavyVehicule.answer}
${this.pregunta7HeavyVehicule.questions}: ${this.pregunta7HeavyVehicule.answer}
${this.pregunta8HeavyVehicule.questions}: ${this.pregunta8HeavyVehicule.answer}`;
  }
  concatenarPreguntasPsychology() {
    this.comment = `${this.pregunta1Psychology.questions}: ${this.pregunta1Psychology.answer}
${this.pregunta2Psychology.questions}: ${this.pregunta2Psychology.answer}
${this.pregunta3Psychology.questions}: ${this.pregunta3Psychology.answer}
${this.pregunta4Psychology.questions}: ${this.pregunta4Psychology.answer}
${this.pregunta5Psychology.questions}: ${this.pregunta5Psychology.answer}
${this.pregunta6Psychology.questions}: ${this.pregunta6Psychology.answer}
${this.pregunta7Psychology.questions}: ${this.pregunta7Psychology.answer}
${this.pregunta8Psychology.questions}: ${this.pregunta8Psychology.answer}`;
  }
  concatenarPreguntasTechnological() {
    this.comment = `${this.pregunta1Technological.questions}: ${this.pregunta1Technological.answer}
${this.pregunta2Technological.questions}: ${this.pregunta2Technological.answer}
${this.pregunta3Technological.questions}: ${this.pregunta3Technological.answer}
${this.pregunta4Technological.questions}: ${this.pregunta4Technological.answer}
${this.pregunta5Technological.questions}: ${this.pregunta5Technological.answer}`;
  }

  concatenarPreguntasLegal() {
    this.comment = `${this.pregunta1Legal.questions}: ${this.pregunta1Legal.answer}
${this.pregunta2Legal.questions}: ${this.pregunta2Legal.answer}
${this.pregunta3Legal.questions}: ${this.pregunta3Legal.answer}
${this.pregunta4Legal.questions}: ${this.pregunta4Legal.answer}
${this.pregunta5Legal.questions}: ${this.pregunta5Legal.answer}`;
  }
  concatenarPreguntasAma() {
    this.comment = `${this.pregunta1Ama.questions}: ${this.pregunta1Ama.answer}
${this.pregunta2Ama.questions}: ${this.pregunta2Ama.answer}
${this.pregunta3Ama.questions}: ${this.pregunta3Ama.answer}
${this.pregunta4Ama.questions}: ${this.pregunta4Ama.answer}
${this.pregunta5Ama.questions}: ${this.pregunta5Ama.answer}
${this.pregunta6Ama.questions}: ${this.pregunta6Ama.answer}`;
  }

  concatenarPreguntasDental() {
    this.comment = `${this.pregunta1Dental.questions}: ${this.pregunta1Dental.answer}
${this.pregunta2Dental.questions}: ${this.pregunta2Dental.answer}
${this.pregunta3Dental.questions}: ${this.pregunta3Dental.answer}
${this.pregunta4Dental.questions}: ${this.pregunta4Dental.answer}
${this.pregunta5Dental.questions}: ${this.pregunta5Dental.answer}
${this.pregunta6Dental.questions}: ${this.pregunta6Dental.answer}
${this.pregunta7Dental.questions}: ${this.pregunta7Dental.answer}
${this.pregunta8Dental.questions}: ${this.pregunta8Dental.answer}
${this.pregunta9Dental.questions}: ${this.pregunta9Dental.answer}`;
  }
  concatenarPreguntasVetAmbulancia() {
    this.comment = `${this.pregunta1VetAmbulancia.questions}: ${this.pregunta1VetAmbulancia.answer}
${this.pregunta2VetAmbulancia.questions}: ${this.pregunta2VetAmbulancia.answer}
${this.pregunta3VetAmbulancia.questions}: ${this.pregunta3VetAmbulancia.answer}
${this.pregunta4VetAmbulancia.questions}: ${this.pregunta4VetAmbulancia.answer}
${this.pregunta5VetAmbulancia.questions}: ${this.pregunta5Dental.answer}
${this.pregunta6VetAmbulancia.questions}: ${this.pregunta6VetAmbulancia.answer}`;
  }
  concatenarPreguntasVetVisitaDomiciliar() {
    this.comment = `${this.pregunta1VetVistD.questions}: ${this.pregunta1VetVistD.answer}
${this.pregunta2VetVistD.questions}: ${this.pregunta2VetVistD.answer}
${this.pregunta3VetVistD.questions}: ${this.pregunta3VetVistD.answer}
${this.pregunta4VetVistD.questions}: ${this.pregunta4VetVistD.answer}
${this.pregunta5VetVistD.questions}: ${this.pregunta5VetVistD.answer}
${this.pregunta6VetVistD.questions}: ${this.pregunta6VetVistD.answer}
${this.pregunta7VetVistD.questions}: ${this.pregunta7VetVistD.answer}
${this.pregunta8VetVistD.questions}: ${this.pregunta8VetVistD.answer}`;
  }

  concatenarPreguntasVetVisitaClinica() {
    this.comment = `${this.pregunta1VetVistC.questions}: ${this.pregunta1VetVistC.answer}
${this.pregunta2VetVistC.questions}: ${this.pregunta2VetVistC.answer}
${this.pregunta3VetVistC.questions}: ${this.pregunta3VetVistC.answer}
${this.pregunta4VetVistC.questions}: ${this.pregunta4VetVistC.answer}
${this.pregunta5VetVistC.questions}: ${this.pregunta5VetVistC.answer}
${this.pregunta6VetVistC.questions}: ${this.pregunta6VetVistC.answer}
${this.pregunta7VetVistC.questions}: ${this.pregunta7VetVistC.answer}
${this.pregunta8VetVistC.questions}: ${this.pregunta8VetVistC.answer}`;
  }

  contatenarPreguntasGasolina() {
    this.comment = `${this.pregunta1Gasolina.questions}: ${this.pregunta1Gasolina.answer}
${this.pregunta2Gasolina.questions}: ${this.pregunta2Gasolina.answer}
${this.pregunta3Gasolina.questions}: ${this.pregunta3Gasolina.answer}
${this.pregunta4Gasolina.questions}: ${this.pregunta4Gasolina.answer}
${this.pregunta5Gasolina.questions}: ${this.pregunta5Gasolina.answer}
${this.pregunta6Gasolina.questions}: ${this.pregunta6Gasolina.answer}`;
  }

  concatenarPreguntasVisita() {
    this.comment = `${this.pregunta1Visita.questions}: ${this.pregunta1Visita.answer}
${this.pregunta2Visita.questions}: ${this.pregunta2Visita.answer}
${this.pregunta3Visita.questions}: ${this.pregunta3Visita.answer}
${this.pregunta4Visita.questions}: ${this.pregunta4Visita.answer}
${this.pregunta5Visita.questions}: ${this.pregunta5Visita.answer}
${this.pregunta6Visita.questions}: ${this.pregunta6Visita.answer}
${this.pregunta7Visita.questions}: ${this.pregunta7Visita.answer}`;
  }

  contatenarPreguntasPasoCorriente() {
    let pregunta1 = `${this.pregunta1PasoCorriente.questions}: ${this.pregunta1PasoCorriente.answer}`;
    if (this.pregunta1PasoCorriente.answer == 'No') {
      pregunta1 = `${this.pregunta1PasoCorriente.questions}: ${this.pregunta1PasoCorriente.answer}, ${this.pregunta1Sub1PasoCorriente.questions}: ${this.pregunta1Sub1PasoCorriente.answer}`;
    }

    let pregunta2 = `${this.pregunta2PasoCorriente.questions}: ${this.pregunta2PasoCorriente.answer}`;
    if (this.pregunta2PasoCorriente.answer == 'Otro') {
      pregunta2 = `${this.pregunta2PasoCorriente.questions}: ${this.pregunta2Sub2PasoCorriente.answer}`;
    }

    this.comment = `${pregunta1}
${pregunta2}
${this.pregunta3PasoCorriente.questions}: ${this.pregunta3PasoCorriente.answer}
${this.pregunta4PasoCorriente.questions}: ${this.pregunta4PasoCorriente.answer}
${this.pregunta5PasoCorriente.questions}: ${this.pregunta5PasoCorriente.answer}
${this.pregunta6PasoCorriente.questions}: ${this.pregunta6PasoCorriente.answer}`;
  }

  contatenarPreguntasCambioDeLlantas() {
    this.comment = `${this.pregunta1CambioDeLlantas.questions}: ${this.pregunta1CambioDeLlantas.answer}
    ${this.pregunta2CambioDeLlantas.questions}: ${this.pregunta2CambioDeLlantas.answer}
    ${this.pregunta3CambioDeLlantas.questions}: ${this.pregunta3CambioDeLlantas.answer}
${this.pregunta4CambioDeLlantas.questions}: ${this.pregunta4CambioDeLlantas.answer}
${this.pregunta5CambioDeLlantas.questions}: ${this.pregunta5CambioDeLlantas.answer}
${this.pregunta6CambioDeLlantas.questions}: ${this.pregunta6CambioDeLlantas.answer}
`;
  }

  contatenarPreguntasEmergencia() {
    this.comment = `${this.pregunta1Emergencia.questions}: ${this.pregunta1Emergencia.answer}
    ${this.pregunta2Emergencia.questions}: ${this.pregunta2Emergencia.answer}
    ${this.pregunta3Emergencia.questions}: ${this.pregunta3Emergencia.answer}
    ${this.pregunta4Emergencia.questions}: ${this.pregunta4Emergencia.answer}
    ${this.pregunta5Emergencia.questions}: ${this.pregunta5Emergencia.answer}
    ${this.pregunta6Emergencia.questions}: ${this.pregunta6Emergencia.answer}
    ${this.pregunta7Emergencia.questions}: ${this.pregunta7Emergencia.answer}
    ${this.pregunta8Emergencia.questions}: ${this.pregunta8Emergencia.answer}`;
  }

  contatenarPreguntasGrua() {
    this.comment = `${this.pregunta1Grua.questions}: ${this.pregunta1Grua.answer}
    ${this.pregunta2Grua.questions}: ${this.pregunta2Grua.answer}
    ${this.pregunta3Grua.questions}: ${this.pregunta3Grua.answer}
    ${this.pregunta4Grua.questions}: ${this.pregunta4Grua.answer}
    ${this.pregunta5Grua.questions}: ${this.pregunta5Grua.answer}
    ${this.pregunta6Grua.questions}: ${this.pregunta6Grua.answer}
    ${this.pregunta7Grua.questions}: ${this.pregunta7Grua.answer}
    ${this.pregunta8Grua.questions}: ${this.pregunta8Grua.answer}
    ${this.pregunta9Grua.questions}: ${this.pregunta9Grua.answer}
    ${this.pregunta10Grua.questions}: ${this.pregunta10Grua.answer}
    ${this.pregunta11Grua.questions}: ${this.pregunta11Grua.answer}
    ${this.pregunta12Grua.questions}: ${this.pregunta12Grua.answer}`;
  }

  contatenarPreguntasUrgencia() {
    this.comment = `${this.pregunta1Urgencia.questions}: ${this.pregunta1Urgencia.answer}
    ${this.pregunta2Urgencia.questions}: ${this.pregunta2Urgencia.answer}
    ${this.pregunta3Urgencia.questions}: ${this.pregunta3Urgencia.answer}
    ${this.pregunta6Urgencia.questions}: ${this.pregunta6Urgencia.answer}
    ${this.pregunta7Urgencia.questions}: ${this.pregunta7Urgencia.answer}
    ${this.pregunta8Urgencia.questions}: ${this.pregunta8Urgencia.answer}
    ${this.pregunta9Urgencia.questions}: ${this.pregunta9Urgencia.answer}
    ${this.pregunta10Urgencia.questions}: ${this.pregunta10Urgencia.answer}`;
  }

  contatenarPreguntasNoUrgencia() {
    this.comment = `${this.pregunta1Urgencia.questions}: ${this.pregunta1Urgencia.answer}
    ${this.pregunta2Urgencia.questions}: ${this.pregunta2Urgencia.answer}
    ${this.pregunta3Urgencia.questions}: ${this.pregunta3Urgencia.answer}
    ${this.pregunta6Urgencia.questions}: ${this.pregunta6Urgencia.answer}
    ${this.pregunta7Urgencia.questions}: ${this.pregunta7Urgencia.answer}
    ${this.pregunta8Urgencia.questions}: ${this.pregunta8Urgencia.answer}
    ${this.pregunta9Urgencia.questions}: ${this.pregunta9Urgencia.answer}
    ${this.pregunta10Urgencia.questions}: ${this.pregunta10Urgencia.answer}`;

    let pregunta2 = `${this.pregunta2CambioDeLlantas.questions}: ${this.pregunta2CambioDeLlantas.answer}, ${this.pregunta2Sub1CambioDeLlantas.questions}: ${this.pregunta2Sub1CambioDeLlantas.answer}`;

    this.comment = `${this.pregunta1CambioDeLlantas.questions}: ${this.pregunta1CambioDeLlantas.answer}
${pregunta2}
${this.pregunta3CambioDeLlantas.questions}: ${this.pregunta3CambioDeLlantas.answer}
${this.pregunta4CambioDeLlantas.questions}: ${this.pregunta4CambioDeLlantas.answer}
${this.pregunta5CambioDeLlantas.questions}: ${this.pregunta5CambioDeLlantas.answer}
${this.pregunta6CambioDeLlantas.questions}: ${this.pregunta6CambioDeLlantas.answer}`;
  }

  concatenarPreguntasVidrieria() {
    this.comment = `
      ${this.pregunta5Vidrieria.questions}: ${this.pregunta5Vidrieria.answer}
      ${this.pregunta6Vidrieria.questions}: ${this.pregunta6Vidrieria.answer}
      ${this.pregunta1Vidrieria.questions}: ${this.pregunta1Vidrieria.answer}
      ${this.pregunta2Vidrieria.questions}: ${this.pregunta2Vidrieria.answer}
      ${this.pregunta3Vidrieria.questions}: ${this.pregunta3Vidrieria.answer}
      ${this.pregunta4Vidrieria.questions}: ${this.pregunta4Vidrieria.answer}
    `;
  }

  concatenarPreguntasPlomeria() {
    this.comment = `
      ${this.pregunta5Plomeria.questions}: ${this.pregunta5Plomeria.answer}
      ${this.pregunta6Plomeria.questions}: ${this.pregunta6Plomeria.answer}
      ${this.pregunta1Plomeria.questions}: ${this.pregunta1Plomeria.answer}
      ${this.pregunta2Plomeria.questions}: ${this.pregunta2Plomeria.answer}
      ${this.pregunta3Plomeria.questions}: ${this.pregunta3Plomeria.answer}
      ${this.pregunta4Plomeria.questions}: ${this.pregunta4Plomeria.answer}
    `;
  }
  concatenarPreguntasCerrajeriaDomiciliar() {
    let opt4;
    let opt5;
    if (this.pregunta7CerrajeriaDomiciliar.answer == 'Otro') {
      opt4 = `${this.pregunta7CerrajeriaDomiciliar.questions}: ${this.pregunta7_1CerrajeriaDomiciliar.answer}`;
    } else {
      opt4 = `${this.pregunta7CerrajeriaDomiciliar.questions}: ${this.pregunta7CerrajeriaDomiciliar.answer}`;
    }

    if (this.pregunta8CerrajeriaDomiciliar.answer == 'Otro') {
      opt5 = `${this.pregunta8CerrajeriaDomiciliar.questions} Otro: ${this.pregunta8_1CerrajeriaDomiciliar.answer}`;
    } else {
      opt5 = `${this.pregunta8CerrajeriaDomiciliar.questions}: ${this.pregunta8CerrajeriaDomiciliar.answer}`;
    }
    this.comment = `
      ${this.pregunta1CerrajeriaDomiciliar.questions}: ${this.pregunta1CerrajeriaDomiciliar.answer}
      ${this.pregunta2CerrajeriaDomiciliar.questions}: ${this.pregunta2CerrajeriaDomiciliar.answer}
      ${this.pregunta3CerrajeriaDomiciliar.questions}: ${this.pregunta3CerrajeriaDomiciliar.answer}
      ${this.pregunta4CerrajeriaDomiciliar.questions}: ${this.pregunta4CerrajeriaDomiciliar.answer}
      ${this.pregunta5CerrajeriaDomiciliar.questions}: ${this.pregunta5CerrajeriaDomiciliar.answer}
      ${this.pregunta6CerrajeriaDomiciliar.questions}: ${this.pregunta6CerrajeriaDomiciliar.answer}
      ${opt4}
      ${opt5}
      ${this.pregunta9CerrajeriaDomiciliar.questions}: ${this.pregunta9CerrajeriaDomiciliar.answer}
    `;
  }

  concatenarPreguntasCerrajeriaVial() {
    this.comment = `
      ${this.pregunta1CerrajeriaVial.questions}: ${this.pregunta1CerrajeriaVial.answer}
      ${this.pregunta2CerrajeriaVial.questions}: ${this.pregunta2CerrajeriaVial.answer}
      ${this.pregunta3CerrajeriaVial.questions}: ${this.pregunta3CerrajeriaVial.answer}
      ${this.pregunta4CerrajeriaVial.questions}: ${this.pregunta4CerrajeriaVial.answer}
      ${this.pregunta5CerrajeriaVial.questions}: ${this.pregunta5CerrajeriaVial.answer}
    `;
  }

  concatenarPreguntasElectricidad() {
    this.comment = `
    ${this.pregunta3Electricidad.questions}: ${this.pregunta3Electricidad.answer}
    ${this.pregunta4Electricidad.questions}: ${this.pregunta4Electricidad.answer}
    ${this.pregunta1Electricidad.questions}: ${this.pregunta1Electricidad.answer}
    ${this.pregunta2Electricidad.questions}: ${this.pregunta2Electricidad.answer}
  `;
  }

  concatenarPreguntasOT() {
    this.comment = `
    ${this.pregunta1OT.questions}: ${this.pregunta1OT.answer}
    ${this.pregunta2OT.questions}: ${this.pregunta2OT.answer}
  `;
  }

  concatenarPreguntasOMT() {
    this.comment = `
    ${this.pregunta1OMT.questions}: ${this.pregunta1OMT.answer}
    ${this.pregunta2OMT.questions}: ${this.pregunta2OMT.answer}
    ${this.pregunta3OMT.questions}: ${this.pregunta3OMT.answer}
    ${this.pregunta4OMT.questions}: ${this.pregunta4OMT.answer}
    ${this.pregunta5OMT.questions}: ${this.pregunta5OMT.answer}
    ${this.pregunta6OMT.questions}: ${this.pregunta6OMT.answer}
  `;
  }

  concatenarPreguntasOVT() {
    this.comment = `
    ${this.pregunta1OVT.questions}: ${this.pregunta1OVT.answer}
    ${this.pregunta2OVT.questions}: ${this.pregunta2OVT.answer}
    ${this.pregunta3OVT.questions}: ${this.pregunta3OVT.answer}
    ${this.pregunta4OVT.questions}: ${this.pregunta4OVT.answer}
    ${this.pregunta5OVT.questions}: ${this.pregunta5OVT.answer}
    ${this.pregunta6OVT.questions}: ${this.pregunta6OVT.answer}
    ${this.pregunta7OVT.questions}: ${this.pregunta7OVT.answer}
  `;
  }

  concatenarPreguntasSrvPantalla() {
    this.comment = `
    ${this.pregunta1SrvPantalla.questions}: ${this.pregunta1SrvPantalla.answer}
    ${this.pregunta2SrvPantalla.questions}: ${this.pregunta2SrvPantalla.answer}
    ${this.pregunta3SrvPantalla.questions}: ${this.pregunta3SrvPantalla.answer}
    ${this.pregunta4SrvPantalla.questions}: ${this.pregunta4SrvPantalla.answer}
    ${this.pregunta5SrvPantalla.questions}: ${this.pregunta5SrvPantalla.answer}
    ${this.pregunta6SrvPantalla.questions}: ${this.pregunta6SrvPantalla.answer}
    ${this.pregunta7SrvPantalla.questions}: ${this.pregunta7SrvPantalla.answer}
    ${this.pregunta8SrvPantalla.questions}: ${this.pregunta8SrvPantalla.answer}
    ${this.pregunta9SrvPantalla.questions}: ${this.pregunta9SrvPantalla.answer}
    ${this.pregunta10SrvPantalla.questions}: ${this.pregunta10SrvPantalla.answer}
    ${this.pregunta11SrvPantalla.questions}: ${this.pregunta11SrvPantalla.answer}
    ${this.pregunta12SrvPantalla.questions}: ${this.pregunta12SrvPantalla.answer}
    ${this.pregunta13SrvPantalla.questions}: ${this.pregunta13SrvPantalla.answer}
    ${this.pregunta14SrvPantalla.questions}: ${this.pregunta14SrvPantalla.answer}
    ${this.pregunta15SrvPantalla.questions}: ${this.pregunta15SrvPantalla.answer}
    ${this.pregunta16SrvPantalla.questions}: ${this.pregunta16SrvPantalla.answer}
    ${this.pregunta17SrvPantalla.questions}: ${this.pregunta17SrvPantalla.answer}
    ${this.pregunta18SrvPantalla.questions}: ${this.pregunta18SrvPantalla.answer}
    ${this.pregunta19SrvPantalla.questions}: ${this.pregunta19SrvPantalla.answer}
    ${this.pregunta20SrvPantalla.questions}: ${this.pregunta20SrvPantalla.answer}
    ${this.pregunta21SrvPantalla.questions}: ${this.pregunta21SrvPantalla.answer}
  `;
  }
  concatenarPreguntasCitasPresenciales() {
    this.comment = `
    ${this.pregunta1CitasPresenciales.questions}: ${this.pregunta1CitasPresenciales.answer}
    ${this.pregunta2CitasPresenciales.questions}: ${this.pregunta2CitasPresenciales.answer}
    ${this.pregunta3CitasPresenciales.questions}: ${this.pregunta3CitasPresenciales.answer}
    ${this.pregunta4CitasPresenciales.questions}: ${this.pregunta4CitasPresenciales.answer}
    ${this.pregunta5CitasPresenciales.questions}: ${this.pregunta5CitasPresenciales.answer}
    ${this.pregunta6CitasPresenciales.questions}: ${this.pregunta6CitasPresenciales.answer}
    ${this.pregunta7CitasPresenciales.questions}: ${this.pregunta7CitasPresenciales.answer}
    ${this.pregunta8CitasPresenciales.questions}: ${this.pregunta8CitasPresenciales.answer}
    ${this.pregunta9CitasPresenciales.questions}: ${this.pregunta9CitasPresenciales.answer}
    ${this.pregunta10CitasPresenciales.questions}: ${this.pregunta10CitasPresenciales.answer}
  `;
  }
  concatenarPreguntasLaboratorios() {
    this.comment = `
    ${this.pregunta1Laboratorios.questions}: ${this.pregunta1Laboratorios.answer}
    ${this.pregunta2Laboratorios.questions}: ${this.pregunta2Laboratorios.answer}
    ${this.pregunta3Laboratorios.questions}: ${this.pregunta3Laboratorios.answer}
    ${this.pregunta4Laboratorios.questions}: ${this.pregunta4Laboratorios.answer}
    ${this.pregunta5Laboratorios.questions}: ${this.pregunta5Laboratorios.answer}
    ${this.pregunta6Laboratorios.questions}: ${this.pregunta6Laboratorios.answer}
    ${this.pregunta7Laboratorios.questions}: ${this.pregunta7Laboratorios.answer}
    ${this.pregunta8Laboratorios.questions}: ${this.pregunta8Laboratorios.answer}
    ${this.pregunta9Laboratorios.questions}: ${this.pregunta9Laboratorios.answer}
    ${this.pregunta10Laboratorios.questions}: ${this.pregunta10Laboratorios.answer}
    ${this.pregunta11Laboratorios.questions}: ${this.pregunta11Laboratorios.answer}
    ${this.pregunta12Laboratorios.questions}: ${this.pregunta12Laboratorios.answer}
  `;
  }
  concatenarPreguntasSiniestroVial() {
    if (!this.pregunta6SiniestroVial.answer) {
      this.pregunta6SiniestroVial.answer = 0;
    }

    this.comment = `
    ${this.pregunta1SiniestroVial.questions}: ${this.pregunta1SiniestroVial.answer}
    ${this.pregunta2SiniestroVial.questions}: ${this.pregunta2SiniestroVial.answer}
    ${this.pregunta5SiniestroVial.questions}: ${this.pregunta5SiniestroVial.answer}
    ${this.pregunta6SiniestroVial.questions}: ${this.pregunta6SiniestroVial.answer}
  `;

    this.comment += `${this.pregunta8SiniestroVial.questions}: ${this.pregunta8SiniestroVial.answer}`;
    let injureds = [];

    if (
      this.additionalplanservice.sinister_apply == 1
    ) {
      this.commentJSON = {
        pilot: this.pregunta1SiniestroVial?.answer,
        authority_responsible: this.pregunta2SiniestroVial?.answer,
        persons_involved: this.pregunta5SiniestroVial?.answer,
        quantity: this.pregunta6SiniestroVial?.answer,
        cabin_comment: this.pregunta8SiniestroVial?.answer,
        comment: this.comment,
      };
    }
  }
  showQuestionsAndAnswer(service_id: number) {
    if (service_id == TYPE_SERVICES.TYPE_TRUCK) {
      this.contatenarPreguntas();
    } else if (service_id == TYPE_SERVICES.TYPE_CURRENT_FLOW) {
      this.contatenarPreguntasPasoCorriente();
    } else if (service_id == TYPE_SERVICES.TYPE_GASOLINE) {
      this.contatenarPreguntasGasolina();
    } else if (service_id == TYPE_SERVICES.TYPE_TIRE_CHANGE) {
      this.contatenarPreguntasCambioDeLlantas();
    } else if (service_id == TYPE_SERVICES.TYPE_LOCK_SMITH) {
      this.contatenarPreguntasCerrajero();
    } else if (TYPE_SERVICES.TYPE_NUTRICIONAL.includes(service_id)) {
      this.concatenarPreguntasNutricional();
    } else if (TYPE_SERVICES.TYPE_MEDICAL_TRANSFER.includes(service_id)) {
      this.concatenarPreguntasMedicalTransfer();
    } else if (TYPE_SERVICES.TYPE_HEAVY_VEHICULE.includes(service_id)) {
      this.concatenarPreguntasHeavyVehicule();
    } else {
      this.comment = '';
    }
  }

  onClickInfo(index) {
    this.indexselectsale = index;
    this.op.show(event);
  }
  triageok_() {
    if (
      this.triageok == false &&
      this.ambulance_id.indexOf(this.editticket.service_id) >= 0
    ) {
      return false;
    } else {
      return true;
    }
  }
  setRed() {
    this.triageok = true;
    this.stopLightNumber = 1;
    this.editticket.triage = 1;
    this.pregunta1Emergencia.answer = this.assistancecase.phone;
  }
  setYellow() {
    this.triageok = true;
    this.stopLightNumber = 2;
    this.editticket.triage = 2;

    this.pregunta1Urgencia.answer = this.assistancecase.phone;
  }
  setGreen() {
    this.triageok = true;
    this.stopLightNumber = 3;
    this.editticket.triage = 3;

    this.pregunta1Urgencia.answer = this.assistancecase.phone;
  }
  getclass1(n) {
    if (n == this.stopLightNumber) {
      return 'redbuttonselect';
    } else {
      return 'redbutton';
    }
  }

  getclass2(n) {
    if (n == this.stopLightNumber) {
      return 'yellowbuttonselect';
    } else {
      return 'yellowbutton';
    }
  }

  getclass3(n) {
    if (n == this.stopLightNumber) {
      return 'greenbuttonselect';
    } else {
      return 'greenbutton';
    }
  }

  ASSISTANCE_SALE_STATUSES_TEXT: any = {
    1: 'Active',
    2: 'Delayed',
    3: 'Canceled',
    4: 'Retencion',
    5: 'Cliente en Mora',
    6: 'Envio de Kit',
  };

  getStatusText(status: any) {
    if (status in this.ASSISTANCE_SALE_STATUSES_TEXT) {
      return this.ASSISTANCE_SALE_STATUSES_TEXT[status];
    }
    if (status && this.is_mok_search) {
      return this.ASSISTANCE_SALE_STATUSES_TEXT[1]
    }
    return '';
  }

  setCreateCaseByConnection() {
    this.SALE_CANCELLED_THEN_BY_CONNECTION = true;
    this.displayButtonByConnection(true);
  }

  onSelectProgramSubType_(event, code) {
    let value2 = event.target.value;

    this.program_subtype = +code || null;
  }

  onSelectProgramSubType(val) {
    this.loaderService.display(true);

    this.api.assistance_programming_types
      .getsubtypes(val)
      .promise()
      .then(
        (resp) => {
          this.assistance_programming_subtypes = resp;
          this.loaderService.display(false);
        },
        (e) => {
          this.loaderService.display(false);
        }
      );
  }

  showAttachments() {
    this.showUploadFileDialog = true;
    this.getProductAttachments(
      this.assistancecase.assistance_id,
      this.assistancecase.assistance_plan_id
    );
  }

  showCaseHistory() {
    this.setSale.emit(this.sale?.id);
    this.showHistoryDialog = true;
  }

  downloadAttachment(attachment) {
    this.setAttachment.emit(attachment);
    this.showPreviewDialog = true;
  }
  closePreviewAttachment() {
    this.showPreviewDialog = false;
  }

  getProductAttachments(assitanceId, plassistance_plan_idanId) {
    this.api.conditionalAttachments
      .get(assitanceId, plassistance_plan_idanId)
      .promise()
      .then((response) => {
        this.loaderService.display(false);

        this.caseAttachments = response.data;
        this.totalCountCaseAttachments = response.count;
      })
      .catch((e) => {
        this.loaderService.display(false);
      });
  }

  onSelectCountryOrigin(country_id) {
    if (!country_id) {
      return;
    }

    this.country = _.find(this.countries, function (c) {
      return c.id === country_id;
    });

    this.assistancecase.origin_country_id = country_id;

    this.api.states
      .get(this.country.id)
      .promise()
      .then((states) => {
        this.states = states;
      });
    if (this.country.locale.length > 2) {
      this.country.locale = this.country.locale.split('-')[1].toLowerCase();
    }

    this.statesDistrict = [];
    this.assistancecase.state_id = null;
    this.assistancecase.state_district_id = null;

    this.country_code.country_name = this.country.name;
    this.country_code.country_local = this.country.locale;
    this.country_code.iso3166_1 = this.country.iso3166_1;

    this.caseLocation = {
      latitude: null,
      longitude: null,
    };
    this.memberLocation.emit(this.country_code);
  }

  onSelectCountryDestination(country_id) {
    if (!country_id) {
      return;
    }

    let country = _.find(this.countries, function (c) {
      return c.id === country_id;
    });

    this.destination_country = country;

    this.assistancecase.destination_country_id = country_id;

    this.api.states
      .get(country.id)
      .promise()
      .then((states) => {
        this.statesTicket = states;
      });

    if (country.locale.length > 2) {
      country.locale = country.locale.split('-')[1].toLowerCase();
    }

    this.editticket.state_id = null;
    this.editticket.state_area_id = null;
    this.statesDistrictTicket = [];

    let country_code: any = {
      country_name: '',
      country_local: '',
      iso3166_1: '',
    };

    country_code.country_name = country.name;
    country_code.country_local = country.locale;
    country_code.iso3166_1 = country.iso3166_1;

    this.caseLocationDestination = {
      latitude: null,
      longitude: null,
    };
    this.memberLocationDestination.emit(country_code);
  }

  get stateDistrictDestinationLabel(): string {
    return this.destination_country?.state_district_text
      ? this.translate.instant(this.destination_country.state_district_text)
      : `${this.translate.instant('District')} / ${this.translate.instant(
        'Canton'
      )}`;
  }

  get stateDestinationLabel(): string {
    return this.destination_country?.state_text
      ? this.translate.instant(this.destination_country.state_text)
      : `${this.translate.instant('state')} / ${this.translate.instant(
        'Province'
      )}`;
  }

  get stateDistrictLabel(): string {
    return this.country?.state_district_text
      ? this.translate.instant(this.country.state_district_text)
      : `${this.translate.instant('District')} / ${this.translate.instant(
        'Canton'
      )}`;
  }

  get stateLabel(): string {
    return this.country?.state_text
      ? this.translate.instant(this.country.state_text)
      : `${this.translate.instant('state')} / ${this.translate.instant(
        'Province'
      )}`;
  }

  saveMemberData() {
    if (!this.member?.id) {
      this.translate.get('Member not found').subscribe((res: string) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: res,
        });
      });
      return;
    }

    const { contact_name, phone, phone2, email } = this.assistancecase || {};

    Object.assign(this.member, {
      address: this.complete_address2,
      name: contact_name,
      mobile: phone,
      phone2: phone2,
      email: email,
    });

    this.loaderService.display(true);
    this.api.members
      .update(this.member, this.member.id)
      .promise()
      .then((response) => {
        this.loaderService.display(false);
        this.isFieldsMemberDataDisabled = true;
        this.translate
          .get('Customer data has been updated')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              life: 5000,
              summary: 'Aviso',
              detail: res,
            });
          });
      })
      .catch((e) => {
        this.loaderService.display(false);
        this.isFieldsMemberDataDisabled = true;
        this.translate
          .get('Error updating customer data')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res,
            });
          });
      });
  }

  showHomeAddresHistory() {
    if (!this.member?.id) {
      this.translate.get('Member not found').subscribe((res: string) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: res,
        });
      });
      return;
    }

    const dialogRef = this.dialog.open(CustomerAddressHistoryComponent, {
      data: { item_id: this.member.id, type: 2, item_name: 'address' },
      disableClose: true,
      width: '65vw',
    });

    dialogRef.afterClosed().subscribe((result) => {
      return;
    });
  }

  getVehicles(assistanceSaleCar: any[]) {
    if (!assistanceSaleCar?.length) {
      return [];
    }

    return assistanceSaleCar.map((car) => {
      return {
        id: car.id,
        car_plate: car.car_plate,
        car_bran_id: car.car_model?.brand_id,
        car_brand: car.brand_description || car.car_model?.brand?.name,
        car_model_id: car.car_model_id,
        car_model_name: car.model_description || car.car_model?.name,
        car_year: car.car_year,
        car_color: car.car_color,
        color_description: car.color_description,
      };
    });
  }

  onSelectVehicleId(id) {
    const selectedVehicle = this.vehicles.find(
      (vehicle) => vehicle.id === this.selectedVehicleId
    );

    if (selectedVehicle) {
      this.editticket.car_plate = selectedVehicle.car_plate;
      this.selectedBrandId = selectedVehicle.car_bran_id;
      this.onSelectBrand(this.selectedBrandId);
      this.selectModel_id = selectedVehicle.car_model_id;
      this.editticket.car_model = selectedVehicle.car_model_name;
      this.editticket.model_description = selectedVehicle.car_model_name;
      this.selectYear = selectedVehicle.car_year;
      this.onSelectYear(this.selectYear);
      this.editticket.color_description = selectedVehicle.color_description;
      this.onSelectColor(this.editticket.color_description);
    }
  }


  //  generateRandomString(length: number): string {


  //   // const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   // let result = '';
  //   // for (let i = 0; i < length; i++) {
  //   //   result += chars.charAt(Math.floor(Math.random() * chars.length));
  //   // }
  //   // return result;
  // }



  clearCarModelSelection() {
    this.carmodels = [];
    this.selectModel_id = null;
    this.editticket.car_model = null;
    this.editticket.model_description = null;
  }


  getTipologies() {
    this.api.typologies
      .get()
      .params({ catalog: 'member_classification' })
      .promise()
      .then((response) => {
        this.client_classification = response.data[0]?.typologies || [];
      })
      .catch((e) => {
        this.translate
          .get('Error fetching typologies')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`,
            });
          });
      });
  }

  getUrlImageMemberClassification(member_classification: number) {
    let url = '';
    this.client_classification.forEach((element) => {
      if (parseInt(element.value_) === member_classification) {
        url = element.description;
      }
    });
    return url;
  }



  onRadioPhoneChange(value) {
    if (value == 1) {
      this.checkedPhone = true;
      this.checkedPhone2 = false;
      this.selectedPhone = 1;

    } else {
      this.checkedPhone = false;
      this.checkedPhone2 = true;
      this.selectedPhone = 2;

    }
  }

  onSelectCompany(value) {
    if (value == 'mok') {
      this.is_mok_search = true
      this.getSponsorsMok()
    } else {
      this.is_mok_search = false
    }
  }

  getSponsorsMok() {
    this.loaderService.display(true);
    this.api.mok_integration.get_sponsors().promise()
      .then(sponsors => {
        this.sponsors_mok = sponsors[0]
        this.loaderService.display(false);
      });
  }

  onSelectSponsor(value) {
    let sponsor = this.sponsors_mok.find(s => s.id === value)
    this.mok_url = sponsor.url
    this.mok_sponsor_selected = sponsor
    this.country = _.find(this.countries, function (c) {
      return c.id === sponsor.country_id;
    });
  }

  getSearchLabel(type: number): string {
    const TYPE = this.TYPE_SEARCH;
    const labels: { [key: number]: string } = {
      9: 'Client',
      10: 'Assistance Code',
      11: 'National ID',
      12: 'Phone',
      99: 'Car Plate',
      50: 'Engine number',
      55: 'Serial number',
      [TYPE.EMAIL]: 'Email',
      [TYPE.TAX_NUMBER]: 'Tax Identification Number'
    };
    return labels[type] || 'Tax Identification Number';
  }
}
